const ZH_CN =
{
    //navbar 
    "首页": "首页",
    "关于我们": "关于我们",
    "长期签证": "长期签证",
    "房地产": "房地产",
    "教育": "教育",
    "申请流程": "申请流程",
    "国际学校": "国际学校",
    "联系我们": "联系我们",

    //Home
    "悠享阳光  尽在MM2H": "悠享阳光  尽在MM2H",
    "您的第二家园  易马二家": "您的第二家园  易马二家",
    "了解更多": "了解更多",
    "马来西亚": "马来西亚",
    "第二家园计划": "第二家园计划",
    "拥抱自由与幸福的新生活，畅享马来西亚第二家园计划，让幸福永续驻留": "拥抱自由与幸福的新生活，畅享马来西亚第二家园计划，让幸福永续驻留",
    "一人申请": "一人申请",
    "全家获签": "全家获签",
    "永久续签": "永久续签",
    "出入自由": "出入自由",
    "环境优越": "环境优越",
    "高福利": "高福利",
    "为何选择": "为何选择",
    "马来西亚第二家园": "马来西亚第二家园",
    "灵活自由低门槛可撤回的侨居条件": "灵活自由低门槛可撤回的侨居条件",
    "无英语要求、无须资产来源证": "无英语要求、无须资产来源证",
    "5+5年免签证终身可续签，永久居留，进出自由无须重复签证": "5+5年免签证终身可续签，永久居留，进出自由无须重复签证",
    "办理快、周期短(4-8月)办妥即用": "办理快、周期短(4-8月)办妥即用",
    "仅需存入大马银行100万马币资金，第二年后最高提款额是50%或50万马币，以作为买房费用、孩子教育费和医疗费用等。无须放弃国内身份、事业、福利和社会关系。身份可撤回，仅需取回存款无损失": "仅需存入大马银行100万马币资金，第二年后最高提款额是50%或50万马币，以作为买房费用、孩子教育费和医疗费用等。无须放弃国内身份、事业、福利和社会关系。身份可撤回，仅需取回存款无损失",
    "一人主申请，全家可获签，60岁以上的父母可随行，并可带一佣人进入马来西亚。": "一人主申请，全家可获签，60岁以上的父母可随行，并可带一佣人进入马来西亚。",
    "子女就学，父母前往陪读。": "子女就学，父母前往陪读。",
    "揭秘马来西亚": "揭秘马来西亚",
    "第二家园的独特福利": "第二家园的独特福利",
    "发现独特福利，马来西亚第二家园等你揭秘": "发现独特福利，马来西亚第二家园等你揭秘",
    "马来西亚沿袭英国及欧美教育体系，教育水准和文凭均被欧美知名学府承认。子女按国民待遇就读当地学校，接受中英文国际化教育，费用低廉。可让孩子赢在起跑线上。": '马来西亚沿袭英国及欧美教育体系，教育水准和文凭均被欧美知名学府承认。子女按国民待遇就读当地学校，接受中英文国际化教育，费用低廉。可让孩子赢在起跑线上。',
    "马来西亚与欧美国家实行”3+0* 和 ”双联课程”，学生可选择转移课程的方式转赴美、加、英、澳等国修读。可回避雅思门槛，签证也不需回国内办理，颁发英美加澳名校的毕业证书，而费用仅为直接留学的1/4。": "马来西亚与欧美国家实行”3+0* 和 ”双联课程”，学生可选择转移课程的方式转赴美、加、英、澳等国修读。可回避雅思门槛，签证也不需回国内办理，颁发英美加澳名校的毕业证书，而费用仅为直接留学的1/4。",
    "低门槛获取华侨身份，可获免税、子女高考加分、领养第二子女等特别权益。家长不妨选择先移民后留学。": "低门槛获取华侨身份，可获免税、子女高考加分、领养第二子女等特别权益。家长不妨选择先移民后留学。",
    "子女持第二家园签证于大马念大学，毕业后不需转换签证可获得工作许可。": "子女持第二家园签证于大马念大学，毕业后不需转换签证可获得工作许可。",
    "老年幸福生活的乐园": "老年幸福生活的乐园",
    "马来西亚是亚洲最适合居住的国家，也是最受欢迎的移居国家。因为这里有友善温和的人民，较低的生活费用，完善的基础设施，迷人的自然环境，良好的投资环境和多元文化，并且拥有国际高水准的教育医疗系统。": "马来西亚是亚洲最适合居住的国家，也是最受欢迎的移居国家。因为这里有友善温和的人民，较低的生活费用，完善的基础设施，迷人的自然环境，良好的投资环境和多元文化，并且拥有国际高水准的教育医疗系统。",
    "空气好，气温适宜(全年温度介于摄氏21度至32度之间)。无地震海啸火山等地质型自然灾害。": "空气好，气温适宜(全年温度介于摄氏21度至32度之间)。无地震海啸火山等地质型自然灾害。",
    "中马两国文化背景相似，有近1/3华人的马来西亚，中文相当普及，受到众多国内退休养老人士的青睐。": "中马两国文化背景相似，有近1/3华人的马来西亚，中文相当普及，受到众多国内退休养老人士的青睐。",
    "MM2H计划申请流程": "MM2H计划申请流程",
    "免费咨询": "免费咨询",
    "确认申请": "确认申请",
    "指导准备": "指导准备",
    "申请资料": "申请资料",
    "递件申请": "递件申请",
    "接受审核": "接受审核",
    "获得批准函": "获得批准函",
    "到达马来西亚": "到达马来西亚",
    "吉隆坡报道贴签": "吉隆坡报道贴签",
    "申请所需文件": "申请所需文件",
    '护照扫描': '护照扫描',
    '每位申请人的整体护照扫描': '每位申请人的整体护照扫描',
    '所有申请人护照必须超过24个月有效期 (护照记录少于一年以下，必须提供整体旧护照一同扫描)': '所有申请人护照必须超过24个月有效期 (护照记录少于一年以下，必须提供整体旧护照一同扫描)',
    '护照标准照': '护照标准照',
    '标准照(蓝底)- 人头至肩膀': '标准照(蓝底)- 人头至肩膀',
    '每位申请人需提供电子版即可': '每位申请人需提供电子版即可',
    '个人简历': '个人简历',
    '主申请人和配偶(如有陪同) ': '主申请人和配偶(如有陪同)',
    '教育背景及10年的工作简历 (我们提供简历表格)': '教育背景及10年的工作简历 (我们提供简历表格)',
    '无犯罪记录': '无犯罪记录',
    '主申请人、配偶以及父母无犯罪记录(孩子年龄18岁或以上也必须无犯罪记录)': '主申请人、配偶以及父母无犯罪记录(孩子年龄18岁或以上也必须无犯罪记录)',
    '翻译 + 公证 + 马来西亚使馆认证(双认证)': '翻译 + 公证 + 马来西亚使馆认证(双认证)',
    '体检报告': '体检报告',
    '每个人体检申报表': '每个人体检申报表',
    '(表格我们提供,需要交给医生填写签名)': '(表格我们提供,需要交给医生填写签名)',
    '结婚证/出生证': '结婚证/出生证',
    '提供结婚证,孩子出生证,父母关系证明': '提供结婚证,孩子出生证,父母关系证明',
    '翻译 + 公证 + 马来西亚使馆认证(双认证)': '翻译 + 公证 + 马来西亚使馆认证(双认证)',
    '资产证明': '资产证明',
    '150万马币的定期存款证明': '150万马币的定期存款证明',
    '银行流水单(至少3个月与工资单一致)或其他文件正本或公证正本,例如:金存款证明,定期存款等。': '银行流水单(至少3个月与工资单一致)或其他文件正本或公证正本,例如:金存款证明,定期存款等。',
    '收入证明': '收入证明',
    '主申请人和配偶的公司在职证明': '主申请人和配偶的公司在职证明',
    '3个月工资单及3个月银行流水帐(月收入4万马币证明)': '3个月工资单及3个月银行流水帐(月收入4万马币证明)',
    "客户见证": "客户见证",
    "感动之言": "感动之言",
    "家人们对易马海外的真实见证和反馈，分享了他们在马来西亚第二家园计划、房产和国际留学等方面的愉快经历和成功故事，为您提供更深入的了解和信心。": "家人们对易马海外的真实见证和反馈，分享了他们在马来西亚第二家园计划、房产和国际留学等方面的愉快经历和成功故事，为您提供更深入的了解和信心。",
    "马来西亚第二家园计划真是太棒了！": "马来西亚第二家园计划真是太棒了！",
    "我们全家都轻松获得了签证，并享受着美好的生活。谢谢您们的专业服务！": "我们全家都轻松获得了签证，并享受着美好的生活。谢谢您们的专业服务！",
    "张先生": "张先生",
    "感谢团队在整个申请过程中的耐心指导和帮助。现在，我们已经在马来西亚开始新的生活，一切都很顺利！": "感谢团队在整个申请过程中的耐心指导和帮助。现在，我们已经在马来西亚开始新的生活，一切都很顺利！",
    "张女士": "张女士",

    "线上预约，与我们相见!": "线上预约，与我们相见!",
    "姓名": "姓名",
    "电话号码": "电话号码",
    "电邮地址": "电邮地址",
    "项目": "项目",
    "选择项目": "选择项目",
    "联络方式": "联络方式",
    "您的": "您的",
    "您的留言（可选）": "您的留言（可选）",
    "提交": "提交",
    "马来西亚第二家园": "马来西亚第二家园",
    "工作签证": "工作签证",
    "房产": "房产",
    "其他": "其他",
    "请填写此处！": "请填写此处！",
    "打造完美体验": "打造完美体验",
    " 助力无限可能": " 助力无限可能",
    "在追寻马来西亚第二家园（MM2H）的过程中，您无需担心繁琐的申请步骤。我们将全程协助您，确保您的体验轻松顺利。您只需专注于探索美妙的马来西亚，我们会确保您的MM2H申请过程轻松愉快，让您无后顾之忧。让我们携手打开探索马来西亚第二家园的大门，迎接新的未来！": "在追寻马来西亚第二家园（MM2H）的过程中，您无需担心繁琐的申请步骤。我们将全程协助您，确保您的体验轻松顺利。您只需专注于探索美妙的马来西亚，我们会确保您的MM2H申请过程轻松愉快，让您无后顾之忧。让我们携手打开探索马来西亚第二家园的大门，迎接新的未来！",
    "马上启程": "马上启程",
    "最近贴文": "最近贴文",
    "易马海外随旅游局、二家协会出访香港，成功举办大马二家推介会": "易马海外随旅游局、二家协会出访香港，成功举办大马二家推介会",
    "随着2022年底中国出入境限制的逐步放开，大批中国香港人率先出境到日本、韩国、东南亚等地旅游...": "随着2022年底中国出入境限制的逐步放开，大批中国香港人率先出境到日本、韩国、东南亚等地旅游...",
    "views": "views",
    "预订量激增！携程公布中国人今年春节出境游目的地TOP10，附马来西亚最新入境要求！": "预订量激增！携程公布中国人今年春节出境游目的地TOP10，附马来西亚最新入境要求！",
    "三年的漫长等待终于迎来了曙光, 中国关闭边境超过3年...": "三年的漫长等待终于迎来了曙光, 中国关闭边境超过3年...",
    "易马海外随行马来西亚旅游局到访台湾举办马来西亚第二家园推介会，业界热情高涨": "易马海外随行马来西亚旅游局到访台湾举办马来西亚第二家园推介会，业界热情高涨",
    "马来西亚观光局举办台湾业者推介会，首站12日在高雄展览馆登场，邀请南部旅游相关业者与会，盼藉由业者推介会深...": "马来西亚观光局举办台湾业者推介会，首站12日在高雄展览馆登场，邀请南部旅游相关业者与会，盼藉由业者推介会深...",
    "大选后，马来西亚留学会有哪些政策变化？": "大选后，马来西亚留学会有哪些政策变化？",
    "这场被称为“史上最激烈”的大选尘埃落定后，我们也看到了新任首相安华想要做出改变的决心。大选后，马来西亚留...": "这场被称为“史上最激烈”的大选尘埃落定后，我们也看到了新任首相安华想要做出改变的决心。大选后，马来西亚留...",

    //About Us
    "欢迎来到": "欢迎来到",
    "YMG集团": "YMG集团",
    "我们是您值得信赖的马来西亚伙伴。从最初考虑居住到完全融入这片美丽的国度，我们将引导您的每一步。拥有与政府、法律专家和本地人合作关系，确保顺畅、愉悦的迁移体验。加入来自世界各地的满意客户行列，与YMG一起实现梦想。我们期待与您携手开启在马来西亚的新生活。": "我们是您值得信赖的马来西亚伙伴。从最初考虑居住到完全融入这片美丽的国度，我们将引导您的每一步。拥有与政府、法律专家和本地人合作关系，确保顺畅、愉悦的迁移体验。加入来自世界各地的满意客户行列，与YMG一起实现梦想。我们期待与您携手开启在马来西亚的新生活。",
    "YMG总部位于马来西亚的市中心（吉隆坡），我们在中国成都也有蓬勃发展的分支。自2014年成立以来，我们以卓越迁居服务为基石，为外籍人士提供全方位支持，包括签证咨询、教育协助、物业管理和马来西亚的无缝租赁体验。不仅是服务提供者，更是您实现在马来西亚迁居的伙伴。": "YMG总部位于马来西亚的市中心（吉隆坡），我们在中国成都也有蓬勃发展的分支。自2014年成立以来，我们以卓越迁居服务为基石，为外籍人士提供全方位支持，包括签证咨询、教育协助、物业管理和马来西亚的无缝租赁体验。不仅是服务提供者，更是您实现在马来西亚迁居的伙伴。",
    "无论您是投资、学习、退休，还是寻求优质生活，YMG将是您坚实的后盾，助您在马来西亚开启新的人生。立即联系我们，启动您在马来西亚的难忘旅程。": "无论您是投资、学习、退休，还是寻求优质生活，YMG将是您坚实的后盾，助您在马来西亚开启新的人生。立即联系我们，启动您在马来西亚的难忘旅程。",
    "我们的团队": "我们的团队",
    "YMG集团 董事总经理": "YMG集团 董事总经理",
    "KATE KUAN 女士": "KATE KUAN 女士",
    "作为房地产和保险领域杰出的专业人士，Kuan在这个行业拥有十年充满活力的职业生涯。在马来西亚成长的过程中，Kuan的强烈职业道德和创业精神一直是她职业生涯的指导原则。": '作为房地产和保险领域杰出的专业人士，Kuan在这个行业拥有十年充满活力的职业生涯。在马来西亚成长的过程中，Kuan的强烈职业道德和创业精神一直是她职业生涯的指导原则。',
    "作为YMG的领导者，Kuan因在房地产和保险行业的卓越工作而获得了众多奖项和荣誉。": "作为YMG的领导者，Kuan因在房地产和保险行业的卓越工作而获得了众多奖项和荣誉。",
    "YMG集团 物业项目总监": "YMG集团 物业项目总监",
    "IVAN NG 先生": "IVAN NG 先生",
    "Ivan 是 YMG 的销售总监。在马来西亚房地产行业担任物业销售顾问长达十年，Ivan以业界资深的身份熠熠生辉，专攻海外市场。借助在营销方面的专业知识和丰富经验，他牵头国际项目的营销和品牌策划。Ivan独特的知识和技能融合，使他成为跨境成功的不二选择，为展示国际舞台上的房地产提供无与伦比的见解和策略。": "Ivan 是 YMG 的销售总监。在马来西亚房地产行业担任物业销售顾问长达十年，Ivan以业界资深的身份熠熠生辉，专攻海外市场。借助在营销方面的专业知识和丰富经验，他牵头国际项目的营销和品牌策划。Ivan独特的知识和技能融合，使他成为跨境成功的不二选择，为展示国际舞台上的房地产提供无与伦比的见解和策略。",
    "YMG集团 MM2H部门负责人": "YMG集团 MM2H部门负责人",
    "KURT TAN 先生": "KURT TAN 先生",
    "Kurt Tan，马来西亚的第二个家协会副主席，深耕该行业已超过十年。 自2012年开始提供服务以来，已成功为来自世界各地的800多个家庭处理了他们的第二家园，并就生活资产配置提供了专业、客观、切实可行的建议。": "Kurt Tan，马来西亚的第二个家协会副主席，深耕该行业已超过十年。 自2012年开始提供服务以来，已成功为来自世界各地的800多个家庭处理了他们的第二家园，并就生活资产配置提供了专业、客观、切实可行的建议。",
    "YMG集团 教育部门负责人": "YMG集团 教育部门负责人",
    "伊恩 先生": "伊恩 先生",
    "资深的教育留学专家，拥有超过6年的教育行业经验，致力于为学生提供最优质的留学咨询和服务，并成功协助超过300位学生成功录取。与吉隆坡第一梯队优秀国际学校建立了紧密的合作关系，如ISKL，花园国际，满家乐，爱丽丝国际，ISP等等。在国际教育领域积累了丰富的知识和经验，熟悉国际教育体系，了解各个国际学校和课程，熟悉各个国际教育体系和学校，能够根据学生的兴趣和目标为他们推荐最适合的学府。他了解不同学校的特点和优势，帮助学生做出明智的选择。": "资深的教育留学专家，拥有超过6年的教育行业经验，致力于为学生提供最优质的留学咨询和服务，并成功协助超过300位学生成功录取。与吉隆坡第一梯队优秀国际学校建立了紧密的合作关系，如ISKL，花园国际，满家乐，爱丽丝国际，ISP等等。在国际教育领域积累了丰富的知识和经验，熟悉国际教育体系，了解各个国际学校和课程，熟悉各个国际教育体系和学校，能够根据学生的兴趣和目标为他们推荐最适合的学府。他了解不同学校的特点和优势，帮助学生做出明智的选择。",
    "YMG集团 签证部门负责人": "YMG集团 签证部门负责人",
    "Jayden 钟先生": "Jayden 钟先生",
    "钟先生在签证领域拥有10来年经验。曾在马来西亚的签证部门工作，熟悉各种签证类型，包括旅游、工作和学生签证等，已成功为来自世界各地的700多个家庭处理了他们的签证 。 作为签证负责人，我领导着专业团队，致力于为客户提供个性化签证方案，确保顺利申请和获得所需签证。无论您的目的是旅游、工作还是学习，我将与您合作，确保签证申请顺利无阻。": "钟先生在签证领域拥有10来年经验。曾在马来西亚的签证部门工作，熟悉各种签证类型，包括旅游、工作和学生签证等，已成功为来自世界各地的700多个家庭处理了他们的签证 。 作为签证负责人，我领导着专业团队，致力于为客户提供个性化签证方案，确保顺利申请和获得所需签证。无论您的目的是旅游、工作还是学习，我将与您合作，确保签证申请顺利无阻。",
    "愿景": "愿景",
    "成为全球顶尖的合作伙伴，协助来自世界各地的个人和家庭实现在马来西亚建立珍爱第二故乡的梦想。我们的目标是实现客户无缝丰富的过渡，同时为马来西亚的文化融合和经济发展做出贡献。": "成为全球顶尖的合作伙伴，协助来自世界各地的个人和家庭实现在马来西亚建立珍爱第二故乡的梦想。我们的目标是实现客户无缝丰富的过渡，同时为马来西亚的文化融合和经济发展做出贡献。",
    "使命": "使命",
    "在YMG，我们使命是引导并支持个人和家庭实现在马来西亚建立第二故乡的旅程。我们提供优质迁居服务，依靠专业知识和深刻文化理解，确保顺畅过渡，融入多样机会和美丽马来西亚。": "在YMG，我们使命是引导并支持个人和家庭实现在马来西亚建立第二故乡的旅程。我们提供优质迁居服务，依靠专业知识和深刻文化理解，确保顺畅过渡，融入多样机会和美丽马来西亚。",
    "核心价值观": "核心价值观",
    "赋能与卓越": "赋能与卓越",
    "我们坚信凭 YMG 的赋能，能够让个人和家庭在马来西亚打造第二家园的旅程中展翅高飞。": "我们坚信凭 YMG 的赋能，能够让个人和家庭在马来西亚打造第二家园的旅程中展翅高飞。",
    "我们追求在每个服务领域卓越，运用专业知识和广泛网络，确保过渡无缝，体验充实。": "我们追求在每个服务领域卓越，运用专业知识和广泛网络，确保过渡无缝，体验充实。",
    "我们核心价值观强调于赋能，致力于提供最高水平的支持、指导和解决方案，让客户能实现马来西亚居住的梦想。": "我们核心价值观强调于赋能，致力于提供最高水平的支持、指导和解决方案，让客户能实现马来西亚居住的梦想。",
    "加入我们 ": "加入我们 ",
    "踏上马来西亚之旅": "踏上马来西亚之旅",
    "准备将马来西亚居住梦想变成现实吗？加入选择 YMG 的众多个人和家庭。我们将成为您在马来西亚无缝生活的夥伴。立即联络我们，开启您的旅程。": "准备将马来西亚居住梦想变成现实吗？加入选择 YMG 的众多个人和家庭。我们将成为您在马来西亚无缝生活的夥伴。立即联络我们，开启您的旅程。",

    //longterm Pass
    "马来西亚 长期签证": "马来西亚 长期签证",
    "是外籍人士在马来西亚居留的许可证，有效期最长为60个月。目前马来西亚长期签证数量有限制。在申请长期签证前，需向移民局获取配额。": "是外籍人士在马来西亚居留的许可证，有效期最长为60个月。目前马来西亚长期签证数量有限制。在申请长期签证前，需向移民局获取配额。",
    "线上预约": "线上预约",
    "长期签证优势": "长期签证优势",
    '无限制出入境本国籍与马来西亚': '无限制出入境本国籍与马来西亚',
    '自费医疗 / 可购买大马保险和医疗卡': '自费医疗 / 可购买大马保险和医疗卡',
    '可独立法人经商': '可独立法人经商',
    '可在马来西亚工作': '可在马来西亚工作',
    '允许根据大马州属规定购房': '允许根据大马州属规定购房',
    '房贷 (视个人条件而定)': '房贷 (视个人条件而定)',
    '可携带配偶、子女和双父母': '可携带配偶、子女和双父母',
    '可在大马银行开账号': '可在大马银行开账号',
    '18岁以下子女可入读任何国际学校并无需学生签证': '18岁以下子女可入读任何国际学校并无需学生签证',
    "所需条件及材料": '所需条件及材料',
    "条件": "条件",
    "申请年龄": "申请年龄",
    "24至48岁": "24至48岁",
    "办理周期": "办理周期",
    "60天": "60天",
    "无特定的": "无特定的",
    "存款要求": "存款要求",
    "无特定": "无特定",
    "资产要求": "资产要求",
    "无需": "无需",
    "犯罪证明": "犯罪证明",
    "材料": "材料",
    '2寸蓝底照片 (电子版)': '2寸蓝底照片 (电子版)',
    '个人及参与家属': '个人及参与家属',
    '身份证副本 (前后面电子版)': '身份证副本 (前后面电子版)',
    '个人及参与家属': '个人及参与家属',
    '护照副本全本彩色扫描 (包括封面)': '护照副本全本彩色扫描 (包括封面)',
    '个人及参与家属': '个人及参与家属',
    '护照有效期必须长达:  14个月 (一年签证) / 26个月 (两年签证)': '护照有效期必须长达:  14个月 (一年签证) / 26个月 (两年签证)',
    '亲属关系证明': '亲属关系证明',
    '由居委会或公安局开出': '由居委会或公安局开出',
    'A. 扫描PDF文件发给我们\nB. 把公证本原件快递到马来西亚至给我们': 'A. 扫描PDF文件发给我们\nB. 把公证本原件快递到马来西亚至给我们',
    '申请亲属关系证明所需资料': '申请亲属关系证明所需资料',
    '| 户口本首页: 本人页\n| 户主页: 父母个人页': '| 户口本首页: 本人页\n| 户主页: 父母个人页',
    '户口如果是分开的就需要各别提供一份96年后出生的提供出生医学证明、本人和父母的身份证正反面及父母结婚证': '户口如果是分开的就需要各别提供一份96年后出生的提供出生医学证明、本人和父母的身份证正反面及父母结婚证',
    '结婚证正本 (如伴侣伴随)': '结婚证正本 (如伴侣伴随)',
    '翻译 + 公证 + 使馆认证 (双认证)': '翻译 + 公证 + 使馆认证 (双认证)',
    '结婚证英文翻译公证所需资料': '结婚证英文翻译公证所需资料',
    '| 结婚证全本扫描: 共四页, 包括封面 (打开扫描, 不要对折)\n| 夫妻双方的身份证正反面扫描\n| 夫妻户口本首页\n| 夫妻户主页\n| 夫妻双方个人页照片': '| 结婚证全本扫描: 共四页, 包括封面 (打开扫描, 不要对折)\n| 夫妻双方的身份证正反面扫描\n| 夫妻户口本首页\n| 夫妻户主页\n| 夫妻双方个人页照片',
    '夫妻户口分开的，分别提供户口首页、户主页、夫妻双方个人页': '夫妻户口分开的，分别提供户口首页、户主页、夫妻双方个人页',
    '出生证明 (如子女伴随，通常未成年人)': '出生证明 (如子女伴随，通常未成年人)',
    '*申请人是未成年人，无身份证可以不提供*': '*申请人是未成年人，无身份证可以不提供*',
    '出生医学证明公证所需资料': '出生医学证明公证所需资料',
    '| 申请人的出生医学证明扫描件\n| 申请人父母的身份证正反面': '| 申请人的出生医学证明扫描件\n| 申请人父母的身份证正反面',
    '本人和父母户口本资料': '本人和父母户口本资料',
    '| 户口本首页: 本人页\n| 户主页: 父母个人页\n| 父母结婚证照片': '| 户口本首页: 本人页\n| 户主页: 父母个人页\n| 父母结婚证照片',
    '本科毕业证书': "本科毕业证书",
    '翻译+公证+使馆认证双认证': '翻译+公证+使馆认证双认证',
    "准备本科几关系证明 (1个月)": "准备本科几关系证明 (1个月)",
    "提交申请 (1个月)": "提交申请 (1个月)",
    "得申请批准后": "得申请批准后",
    "线上申请 eVisa": "线上申请 eVisa",
    "得到 eVisa": "得到 eVisa",
    "订一周后的飞机票入境 (必须飞往KLIA 1)": "订一周后的飞机票入境 (必须飞往KLIA 1)",
    "申请飞机场贴签函": "申请飞机场贴签函",
    "彩印所有文件": "彩印所有文件",
    "飞往吉隆坡 KLIA 1": "飞往吉隆坡 KLIA 1",
    "过指定海关柜台": "过指定海关柜台",
    "在机场内柜台贴签": "在机场内柜台贴签",
    "办理费用": "办理费用",
    "费用按进度付款": "费用按进度付款",
    "押金": "押金",
    "批文下来后": "批文下来后",
    "主申请人费用": "主申请人费用",
    "2年 : 31,000 马币": "2年 : 31,000 马币",
    "配偶及子女(每位)": "配偶及子女(每位)",
    "10,000 马币": "10,000 马币",
    "父母(每位)": "父母(每位)",

    //Property
    "更多详情": "更多详情",
    "TRX residences TRX 高级豪宅": "TRX residences TRX 高级豪宅",
    "吉隆玻TRX金融中心": "吉隆玻TRX金融中心",
    "The Ashwood": "The Ashwood",
    "吉隆坡安邦使馆区": "吉隆坡安邦使馆区",
    "Bintang Suite 雅居乐天汇 ": "Bintang Suite 雅居乐天汇",
    "吉隆玻武吉免登": "吉隆玻武吉免登",
    "Pavilion damansara height": "Pavilion damansara height",
    "吉隆玻白沙罗高原": "吉隆玻白沙罗高原",
    "Eaton Residences 豪景园": "Eaton Residences 豪景园",
    "吉隆玻市中心": "吉隆玻市中心",
    "Madge Mansion": "Madge Mansion",
    "吉隆玻安邦使馆区": "吉隆玻安邦使馆区",
    "R8 Residences": "R8 Residences",
    "18 Madge 18美景": "18 Madge 18美景",
    "ARIA豪华住宅": "ARIA豪华住宅",
    "AT6": "AT6",

    //Property Details
    "下载文件": "下载文件",
    "永久产权摩天住宅，雅居乐天汇武吉免登，豪华都市生活体验": "永久产权摩天住宅，雅居乐天汇武吉免登，豪华都市生活体验",
    "雅居乐天汇武吉免登，以60层高的摩天大楼为代表，提供豪华住宅公寓，引领都市生活潮流。项目由中国雅居乐与马来西亚丽阳机构合作打造，巧妙融合绿色环境和健康生活，以“五花园”为中心，将热带雨林之美融入现代生活。\n\n此项目拥有4个独特打造的游泳池，包括普通游泳池、嬉水池、浅水池以及水上健身馆。住宅内部设计现代时尚轻奢，由全球十佳建筑设计之一的DP Architects倾心打造，致力于打造吉隆坡的地标级建筑，定制现代时尚轻奢的设计风格。": "雅居乐天汇武吉免登，以60层高的摩天大楼为代表，提供豪华住宅公寓，引领都市生活潮流。项目由中国雅居乐与马来西亚丽阳机构合作打造，巧妙融合绿色环境和健康生活，以“五花园”为中心，将热带雨林之美融入现代生活。\n\n此项目拥有4个独特打造的游泳池，包括普通游泳池、嬉水池、浅水池以及水上健身馆。住宅内部设计现代时尚轻奢，由全球十佳建筑设计之一的DP Architects倾心打造，致力于打造吉隆坡的地标级建筑，定制现代时尚轻奢的设计风格。",
    '位于': '位于',
    '吉隆玻武吉免登路\n与敦拉萨路交界处': '吉隆玻武吉免登路\n与敦拉萨路交界处',
    '售价': '售价',
    'RM830,000 - RM1,300,000': 'RM830,000 - RM1,300,000',
    '面积': '面积',
    '从603平方英尺 - 877平方英尺': '从603平方英尺 - 877平方英尺',
    '业权': '业权',
    '永久业权': '永久业权',
    '车位': '车位',
    '年度完成': '年度完成',
    "都市之光，柏威年白沙罗高原的璀璨未来": "都市之光，柏威年白沙罗高原的璀璨未来",
    "都市之巅，坐落于马来西亚最负盛名的地段，柏威年白沙罗高原正崛起为这一繁荣社区的新中心。这座占地16英亩的永久产权综合性开发项目涵盖豪华住宅、企业办公室和生活方式购物中心，正在创造中的杰作，必将塑造吉隆坡的新天际线。": "都市之巅，坐落于马来西亚最负盛名的地段，柏威年白沙罗高原正崛起为这一繁荣社区的新中心。这座占地16英亩的永久产权综合性开发项目涵盖豪华住宅、企业办公室和生活方式购物中心，正在创造中的杰作，必将塑造吉隆坡的新天际线。",
    "吉隆玻白沙罗": "吉隆玻白沙罗",
    'RM 1,000,000': 'RM 1,000,000',
    '从603平方英尺 - 826平方英尺': '从603平方英尺 - 826平方英尺',
    'Crown 3/2024 & 4/2024': 'Crown 3/2024 & 4/2024',
    "The Exchange TRX：重新定义城市生活的世界级地标": "The Exchange TRX：重新定义城市生活的世界级地标",
    "The Exchange TRX是Lendlease的最新巅峰之作，坐落于Tun Razak Exchange核心地带，是一个适合每个人的世界级地标。作为马来西亚唯一提供独特特色和优势的地方，The Exchange TRX体现了真正的世界级综合生活理念，为社区建设提供绝对便利和无与伦比的连接体验。随着地区成为全球金融中心，居民将享受其强大的价值创造力。": "The Exchange TRX是Lendlease的最新巅峰之作，坐落于Tun Razak Exchange核心地带，是一个适合每个人的世界级地标。作为马来西亚唯一提供独特特色和优势的地方，The Exchange TRX体现了真正的世界级综合生活理念，为社区建设提供绝对便利和无与伦比的连接体验。随着地区成为全球金融中心，居民将享受其强大的价值创造力。",
    '敦拉萨国际贸易中心': '敦拉萨国际贸易中心',
    'RM 900,000': 'RM 900,000',
    '从474平方英尺 - 1,636平方英尺': '从474平方英尺 - 1,636平方英尺',
    '1st Quarter 2024': '1st Quarter 2024',
    "吉隆坡中轴线：尊贵生活，城市全景的豪华体验": "吉隆坡中轴线：尊贵生活，城市全景的豪华体验",
    "位于繁华的吉隆坡中轴线，这个项目不仅彰显了优雅与尊贵，还代表了一种超凡的生活品味。它提供了全景式的自然空间体验，特别是顶楼的无边际泳池，从这里可以俯瞰整个吉隆坡的壮丽景观。这个泳池不仅是吉隆坡最高和最长的空中泳池，更是洗净都市繁华，享受舒心生活的理想之地。坐拥吉隆坡的璀璨风光，每一刻都在创造无限的可能，体现了豪华都市生活的真正情调。": "位于繁华的吉隆坡中轴线，这个项目不仅彰显了优雅与尊贵，还代表了一种超凡的生活品味。它提供了全景式的自然空间体验，特别是顶楼的无边际泳池，从这里可以俯瞰整个吉隆坡的壮丽景观。这个泳池不仅是吉隆坡最高和最长的空中泳池，更是洗净都市繁华，享受舒心生活的理想之地。坐拥吉隆坡的璀璨风光，每一刻都在创造无限的可能，体现了豪华都市生活的真正情调。",
    '吉隆玻 Jalan Eaton': '吉隆玻 Jalan Eaton',
    '从840平方英尺 - 2,960平方英尺': '从840平方英尺 - 2,960平方英尺',
    "Madge Mansion：吉隆坡心脏地带的奢华休憩天堂": "Madge Mansion：吉隆坡心脏地带的奢华休憩天堂",
    "Madge Mansion，在吉隆坡城市核心区域的繁华中矗立，是一处定义了奢华与舒适的住宅胜地。这个尊贵的住所拥有52间独具特色的套房，每一间都是精心设计的艺术品。其公共设施包括一座符合奥林匹克标准、长达50米的无边际游泳池（盐水处理），为您提供了优越的泳池体验。此外，漂浮式木板路、下沉式按摩浴缸以及专用烧烤区和多功能厅，都是为了满足您对品质生活的每一个需求。阳光甲板上种植的植物为您提供天然的遮阳，而广场的倒影池和水景水平营造了一种度假般的环境，使得每一刻都充满放松和享受。Madge Mansion不仅是一个居住的地方，它是一种生活的艺术，一种令人向往的生活方式。": "Madge Mansion，在吉隆坡城市核心区域的繁华中矗立，是一处定义了奢华与舒适的住宅胜地。这个尊贵的住所拥有52间独具特色的套房，每一间都是精心设计的艺术品。其公共设施包括一座符合奥林匹克标准、长达50米的无边际游泳池（盐水处理），为您提供了优越的泳池体验。此外，漂浮式木板路、下沉式按摩浴缸以及专用烧烤区和多功能厅，都是为了满足您对品质生活的每一个需求。阳光甲板上种植的植物为您提供天然的遮阳，而广场的倒影池和水景水平营造了一种度假般的环境，使得每一刻都充满放松和享受。Madge Mansion不仅是一个居住的地方，它是一种生活的艺术，一种令人向往的生活方式。",
    '安邦路': '安邦路',
    '从 RM 5,212,000 起': '从 RM 5,212,000 起',
    '从 1,210 平方英尺 - 1,300 平方英尺': '从 1,210 平方英尺 - 1,300 平方英尺',
    "尊贵体验，大使馆区的低密度奢华住宅": "尊贵体验，大使馆区的低密度奢华住宅",
    "R8 Residensi，象征大使馆区的优雅，这个低密度住宅项目不仅展现了卓越的设计特点，还为每一位居民提供了尖端的安全功能和服务。每个住宅都流露出宏伟和奢华的氛围，由专业人员提供高水准的服务。在R8 Residensi，我们深知重要的不只是有形的豪华设施，而是对细节的关注和个性化的关怀。住在这里，您将体验到像度假村般的定制服务，享受尊贵客人的待遇，感受那些看似微小但极为关键的细节和个人关怀，为您的生活增添更多色彩。": "R8 Residensi，象征大使馆区的优雅，这个低密度住宅项目不仅展现了卓越的设计特点，还为每一位居民提供了尖端的安全功能和服务。每个住宅都流露出宏伟和奢华的氛围，由专业人员提供高水准的服务。在R8 Residensi，我们深知重要的不只是有形的豪华设施，而是对细节的关注和个性化的关怀。住在这里，您将体验到像度假村般的定制服务，享受尊贵客人的待遇，感受那些看似微小但极为关键的细节和个人关怀，为您的生活增添更多色彩。",
    '从 RM 3,120,000 起': '从 RM 3,120,000 起',
    '从 2,725 平方英尺 - 5,118 平方英尺': '从 2,725 平方英尺 - 5,118 平方英尺',
    "18 Madge温泉公寓：吉隆坡中心日式豪华温泉住宅": "18 Madge温泉公寓：吉隆坡中心日式豪华温泉住宅",
    "18 Madge温泉公寓，作为首个融合日式温泉的豪华住宅项目，坐落于吉隆坡市中心的安邦大使馆区域。这个项目以其禅意设计原则，为居住者带来“清新、干净、简洁”的生活体验，超越一般豪华公寓的舒缓流动空间。步入这个宏伟而温馨的社区，即是踏入一个优雅且宁静的理想生活空间。18 Madge温泉公寓的独特设计巧妙融合了自然环境和周边设施，提供了随处可见的轻松与自在。位于Madge路的黄金地段，周围环绕着领事馆、大使馆和国际学校等高端设施，这里不仅是吉隆坡最高贵的地区之一，也完美地结合了舒适、便利与高贵，满足对生活有一定品味和要求的人士。": "18 Madge温泉公寓，作为首个融合日式温泉的豪华住宅项目，坐落于吉隆坡市中心的安邦大使馆区域。这个项目以其禅意设计原则，为居住者带来“清新、干净、简洁”的生活体验，超越一般豪华公寓的舒缓流动空间。步入这个宏伟而温馨的社区，即是踏入一个优雅且宁静的理想生活空间。18 Madge温泉公寓的独特设计巧妙融合了自然环境和周边设施，提供了随处可见的轻松与自在。位于Madge路的黄金地段，周围环绕着领事馆、大使馆和国际学校等高端设施，这里不仅是吉隆坡最高贵的地区之一，也完美地结合了舒适、便利与高贵，满足对生活有一定品味和要求的人士。",
    '安邦大使馆区域': '安邦大使馆区域',
    '从 RM 3,000,000 起': '从 RM 3,000,000 起',
    '从 2,238 平方英尺 - 8,460 平方英尺': '从 2,238 平方英尺 - 8,460 平方英尺',
    "尽享城市精华，紧邻双峰塔的优越生活": "尽享城市精华，紧邻双峰塔的优越生活",
    "ARIA豪华住宅，位于吉隆坡双峰塔附近，是都市生活的完美选择。它位于黄金三角区，周围环绕着顶级购物中心、公园、国际学校和医院。邻近外交区和皇家雪兰莪高尔夫俱乐部，ARIA提供了豪华零售、时尚、美食和休闲娱乐的一站式体验，是都市生活和便利的理想结合。": "ARIA豪华住宅，位于吉隆坡双峰塔附近，是都市生活的完美选择。它位于黄金三角区，周围环绕着顶级购物中心、公园、国际学校和医院。邻近外交区和皇家雪兰莪高尔夫俱乐部，ARIA提供了豪华零售、时尚、美食和休闲娱乐的一站式体验，是都市生活和便利的理想结合。",
    '吉隆坡市中心外交区': '吉隆坡市中心外交区',
    '从 RM 1,100,000 起': '从 RM 1,100,000 起',
    '从 630 平方英尺 - 1,502 平方英尺': '从 630 平方英尺 - 1,502 平方英尺',
    "吉隆坡心脏地带的低密度历史灵感居所": "吉隆坡心脏地带的低密度历史灵感居所",
    "AT6，位于吉隆坡中央安邦路6号，是一处位于著名U-Thant、Madge和Ampang Hilir社区的低密度豪华公寓项目。这个地区以其庞大的大使馆和古老豪宅著称，它们隐匿在成熟雨树的阴影之中，距离KLCC仅咫尺之遥。AT6的设计灵感来源于其周边的历史建筑，模仿了这些古老房子所独有的细致和优雅，致力于为居住者提供一种独特且高雅的生活体验。": "AT6，位于吉隆坡中央安邦路6号，是一处位于著名U-Thant、Madge和Ampang Hilir社区的低密度豪华公寓项目。这个地区以其庞大的大使馆和古老豪宅著称，它们隐匿在成熟雨树的阴影之中，距离KLCC仅咫尺之遥。AT6的设计灵感来源于其周边的历史建筑，模仿了这些古老房子所独有的细致和优雅，致力于为居住者提供一种独特且高雅的生活体验。",
    '吉隆玻安邦路': '吉隆玻安邦路',
    '从 RM 3,500,000 起': '从 RM 3,500,000 起',
    '从 2,799 平方英尺 - 3,509 平方英尺': '从 2,799 平方英尺 - 3,509 平方英尺',
    "The Ashwood：吉隆坡奢华与宁静交融之地": "The Ashwood：吉隆坡奢华与宁静交融之地",
    "在The Ashwood尊贵社区，您将体验无与伦比的奢华生活，地处繁华的吉隆坡市中心。The Ashwood象征着精致与优雅，提供多样化的住宅选择，从时尚宽敞的公寓到独家的复式别墅和奢华别墅。每个住宅均采用现代设计，兼顾舒适性。享受城市生活的便利同时，也能在度假式设施中欣赏城市和郁郁葱葱的高尔夫球场景观。The Ashwood重新定义了城市生活，融合了奢华、便利和宁静。": "在The Ashwood尊贵社区，您将体验无与伦比的奢华生活，地处繁华的吉隆坡市中心。The Ashwood象征着精致与优雅，提供多样化的住宅选择，从时尚宽敞的公寓到独家的复式别墅和奢华别墅。每个住宅均采用现代设计，兼顾舒适性。享受城市生活的便利同时，也能在度假式设施中欣赏城市和郁郁葱葱的高尔夫球场景观。The Ashwood重新定义了城市生活，融合了奢华、便利和宁静。",
    "RM 1,600,000 - RM 4,000,000": "RM 1,600,000 - RM 4,000,000",
    '从1,381平方英尺 - 3,399平方英尺': '从1,381平方英尺 - 3,399平方英尺',
    '2个 到 6个': '2个 到 6个',
    '2027 第3季度': "2027 第3季度",

    //Application Flow
    "马来西亚国际学校申请流程": "马来西亚国际学校申请流程",
    "了解学校": "了解学校",
    "考察": "考察",
    "申请": "申请",
    "录取": "录取",
    "了解学校": "了解学校",
    "马来西亚一共有225家国际学校 来自16个不同城市, 吉隆坡 (38家) 和雪兰莪州 (95家) 分别占 59.1%。这百分比数据 排除非英语教学的学校比如法国, 德国, 台湾, 日本, 韩国, 希克, 印度等学校, 和规模小于200位学生的国际学校, 大约有 35家合适的规模国际学校。": "马来西亚一共有225家国际学校 来自16个不同城市, 吉隆坡 (38家) 和雪兰莪州 (95家) 分别占 59.1%。这百分比数据 排除非英语教学的学校比如法国, 德国, 台湾, 日本, 韩国, 希克, 印度等学校, 和规模小于200位学生的国际学校, 大约有 35家合适的规模国际学校。",
    "英语教学的国际学校主流": "英语教学的国际学校主流",
    "剑桥英式 | IGCSE/A-Level": "剑桥英式 | IGCSE/A-Level",
    "国际 | International Baccalaureate IB": "国际 | International Baccalaureate IB",
    "美式 | Advanced Placement AP": "美式 | Advanced Placement AP",
    "澳大利亚 | HSC/VCE": "澳大利亚 | HSC/VCE",
    "加拿大 | OSSD": "加拿大 | OSSD",
    "英式": "英式",
    "由于马来西亚是英联邦国，大多数吉隆坡的国际名校也以英式教育为主。大多数的马来西亚学生也比较普遍选择到新加坡，澳大利亚，新西兰，英国完成本科学位 。": "由于马来西亚是英联邦国，大多数吉隆坡的国际名校也以英式教育为主。大多数的马来西亚学生也比较普遍选择到新加坡，澳大利亚，新西兰，英国完成本科学位 。",
    "著名英式学校": "著名英式学校",
    "学生": "学生",
    "亩地": "亩地",
    "美式": "美式",
    "美式教育在吉隆坡比较少。 其中最为著名的是吉隆坡国际学校 ，建校于1965年，注重于学生的多方位发展，而学校的学生人数控制在1600-1700位，校园156亩地。是吉隆坡最大和设施最完善的国际学校之一。": "美式教育在吉隆坡比较少。 其中最为著名的是吉隆坡国际学校 ，建校于1965年，注重于学生的多方位发展，而学校的学生人数控制在1600-1700位，校园156亩地。是吉隆坡最大和设施最完善的国际学校之一。",
    "美式学校": "美式学校",
    "家长可以根据易马海外教育员推荐学校清单中挑选心仪的国际学校和国际大学。": "家长可以根据易马海外教育员推荐学校清单中挑选心仪的国际学校和国际大学。",
    '确定目标和需求': '确定目标和需求',
    '考虑到家庭意向的教育理念、学校的课程设置、学术水平、文化氛围和居住环境等因素。': '考虑到家庭意向的教育理念、学校的课程设置、学术水平、文化氛围和居住环境等因素。',
    '筛选出适合的学校': '筛选出适合的学校',
    '根据孩子具体的情况和其它考虑因素比如家庭预算，家庭的日常安排和便利性，筛选出符合条件的学校 。': '根据孩子具体的情况和其它考虑因素比如家庭预算，家庭的日常安排和便利性，筛选出符合条件的学校 。',
    '预约参观': '预约参观',
    '| 我们易马海外教育员会联系选定的国际学校，预约校园参观。参观学校需要提前2-3周跟学校预约, 以确保学校接待和在校学生的安全。\n\n| 在校园参观期间，您可以观察学校的教学环境、设施设备、学生活动等，并与学校老师深入交流。': '| 我们易马海外教育员会联系选定的国际学校，预约校园参观。参观学校需要提前2-3周跟学校预约, 以确保学校接待和在校学生的安全。\n\n| 在校园参观期间，您可以观察学校的教学环境、设施设备、学生活动等，并与学校老师深入交流。',
    '了解课程和教学方式': '了解课程和教学方式',
    '| 询问学校有关课程设置、课程内容、教学方法、师资力量等方面的信息。了解学校的教育理念和价值观是否与您的期望相符。\n\n| 了解学校的学生生活和课外活动安排，包括社团、运动、艺术活动等。考虑学校的文化氛围是否适合您的孩子。': '| 询问学校有关课程设置、课程内容、教学方法、师资力量等方面的信息。了解学校的教育理念和价值观是否与您的期望相符。\n\n| 了解学校的学生生活和课外活动安排，包括社团、运动、艺术活动等。考虑学校的文化氛围是否适合您的孩子。',
    '了解学费和招生策略': '了解学费和招生策略',
    '询问学校的学费标准、收费方式以及招生政策，包括入学条件、申请流程和截止日期等信息。': '询问学校的学费标准、收费方式以及招生政策，包括入学条件、申请流程和截止日期等信息。',
    '参加试听课': '参加试听课',
    '| 询问学校关于试听课（试听课取决于学校是否可以安排）| 如果有，可以安排孩子参加学校的试听课程，以便更直观地了解教学质量和学生体验。': '| 询问学校关于试听课（试听课取决于学校是否可以安排）| 如果有，可以安排孩子参加学校的试听课程，以便更直观地了解教学质量和学生体验。',
    '我们易马海外教育员会协助您进行申请。': "我们易马海外教育员会协助您进行申请。",
    '准备扫描版文件和材料': '准备扫描版文件和材料',
    '您只需要准备扫描版文件和材料': '您只需要准备扫描版文件和材料',
    '学生': '学生',
    '爸爸': '爸爸',
    '妈妈': '妈妈',
    '学生的护照': '学生的护照',
    '学生的白底照片': '学生的白底照片',
    '学生出生证明': '学生出生证明',
    '兴趣和爱好': '兴趣和爱好',
    "标准化考试成绩报告，近 2年（至少 1年）": "标准化考试成绩报告，近 2年（至少 1年）",
    "个人陈述（个人简介）": "个人陈述（个人简介）",
    "目前就读": "目前就读",
    "学校地址": "学校地址",
    "学校联系号码": "学校联系号码",
    "在校老师姓名": "在校老师姓名",
    "在校老师邮箱": "在校老师邮箱",
    "在校老师推荐信（如果有需要)": "在校老师推荐信（如果有需要)",
    "其它": "其它",
    "父亲": "父亲",
    "父亲的护照": "父亲的护照",
    "父亲的白底照片": "父亲的白底照片",
    "父母结婚证 /离婚证": "父母结婚证 /离婚证",
    "职业": "职业",
    "就职公司名字": "就职公司名字",
    "就职公司地址": "就职公司地址",
    "公司联系号码": "公司联系号码",
    "邮箱地址": "邮箱地址",
    "手机号码": "手机号码",
    "国内地址": "国内地址",
    "母亲": "母亲",
    "母亲的护照": "母亲的护照",
    "母亲的白底照片": "母亲的白底照片",
    '付款': '付款',
    '参加入学测试': '参加入学测试',
    '测试结果': '测试结果',
    "自己付或代付服务。代付服务会根据当天银行的汇率计算。": "自己付或代付服务。代付服务会根据当天银行的汇率计算。",
    "一些国际学校可能需要申请者参加入学测试。入学测试分两种：": "一些国际学校可能需要申请者参加入学测试。入学测试分两种：",
    "i. 线上 (申请者在国外)": "i. 线上 (申请者在国外)",
    "ii. 线下 (申请者在马来西亚)": "ii. 线下 (申请者在马来西亚)",
    "参加入学测试之前，请准备好展示您的个人素质、兴趣爱好和适应能力。": "参加入学测试之前，请准备好展示您的个人素质、兴趣爱好和适应能力。",
    "一旦我们提交了申请，您就需要等待学校的通知。大多数学校一般会在1至2周通知您是否被录取。": "一旦我们提交了申请，您就需要等待学校的通知。大多数学校一般会在1至2周通知您是否被录取。",
    "帝莎国际学校": "帝莎国际学校",
    "圣约瑟夫国际学校": "圣约瑟夫国际学校",

    //international-school
    "学校简介": "学校简介",
    "基本信息": "基本信息",
    "学术成绩": "学术成绩",
    "吉隆坡": "吉隆坡",
    "蒲种": "蒲种",
    "2023 年 IB 文凭课程成绩": "2023 年 IB 文凭课程成绩",
    "2023 年 IBDP 考试通过率高达": "2023 年 IBDP 考试通过率高达",
    "超过了世界 79.7% 的通过率": "超过了世界 79.7% 的通过率",
    "IGBIS 25% 的学生得分为": "IGBIS 25% 的学生得分为",
    "40 分及以上": "40 分及以上",
    "满分 45 分": "满分 45 分",
    "学费": "学费",
    "教学理念": "教学理念",
    "注重培养三个核心原则：品格、领导力和创新。": "注重培养三个核心原则：品格、领导力和创新。",
    "品格": "品格",
    "了解": "了解",
    "清晰的认识自己，知道自己的价值观和信仰是什么，并在日常生活中坚持这些原则。": "清晰的认识自己，知道自己的价值观和信仰是什么，并在日常生活中坚持这些原则。",
    "关爱": "关爱",
    "一个具有良好品格的人不仅关注自己的利益，还能够关心他人的感受和需要，表现出同情心和善意。": "一个具有良好品格的人不仅关注自己的利益，还能够关心他人的感受和需要，表现出同情心和善意。",
    "要做": "要做",
    "一个具有良好品格的人不仅会意识到他人的需求，还会主动采取行动去帮助他人，或者为了共同的利益和目标而做出牺牲。": "一个具有良好品格的人不仅会意识到他人的需求，还会主动采取行动去帮助他人，或者为了共同的利益和目标而做出牺牲。",
    "领导力": "领导力",
    "视力": "视力",
    "领导者具有敏锐的洞察力，能够发现团队、组织或社会面临的问题和机遇。": "领导者具有敏锐的洞察力，能够发现团队、组织或社会面临的问题和机遇。",
    "聚集": "聚集",
    "领导者不仅能够看到问题和机遇，还能够激发团队成员的共鸣，团结大家共同朝着共同的目标努力。": "领导者不仅能够看到问题和机遇，还能够激发团队成员的共鸣，团结大家共同朝着共同的目标努力。",
    "进行": '进行',
    "领导者不仅仅是指明方向，更重要的是能够带领团队实现目标，通过有效的沟通、协作和决策，推动团队朝着愿景前进。": "领导者不仅仅是指明方向，更重要的是能够带领团队实现目标，通过有效的沟通、协作和决策，推动团队朝着愿景前进。",
    "创新": "创新",
    "想象": "想象",
    "创新者具有丰富的想象力和创造力，能够看到事物的潜在可能性，并从中获得灵感和启发。": "创新者具有丰富的想象力和创造力，能够看到事物的潜在可能性，并从中获得灵感和启发。",
    "尝试": "尝试",
    "创新者愿意尝试新的方法和理念，即使面临失败或挑战，也能保持乐观态度并从中学习经验教训。": "创新者愿意尝试新的方法和理念，即使面临失败或挑战，也能保持乐观态度并从中学习经验教训。",
    "创造": "创造",
    "通过创新，人们能够产生新的产品、服务或解决方案，从而为社会带来实质性的变革和进步。": "通过创新，人们能够产生新的产品、服务或解决方案，从而为社会带来实质性的变革和进步。",
    "奖状/认证": "奖状/认证",
    "泰莱教育集团": "泰莱教育集团",
    "爱丽丝斯密斯国际学校": "爱丽丝斯密斯国际学校",
    "“教育与探索相遇的地方，赋予每个孩子学习的力量，激发勇气和好奇心”\n\n爱丽丝斯密斯国际学校在马来西亚吉隆坡提供基于英国课程、IGCSE 和 A Level 的国际教育，适合 3 至 18 岁的学生。 我们的目标是激发勇敢的探索，激发一个更美好的世界。 我们创新的学习环境使学生能够无所畏惧地探索不同的道路。 我们植根于全球社区，培养创造力和对学习的终生热爱，共同努力建设更光明、更有影响力的未来。": "“教育与探索相遇的地方，赋予每个孩子学习的力量，激发勇气和好奇心”\n\n爱丽丝斯密斯国际学校在马来西亚吉隆坡提供基于英国课程、IGCSE 和 A Level 的国际教育，适合 3 至 18 岁的学生。 我们的目标是激发勇敢的探索，激发一个更美好的世界。 我们创新的学习环境使学生能够无所畏惧地探索不同的道路。 我们植根于全球社区，培养创造力和对学习的终生热爱，共同努力建设更光明、更有影响力的未来。",
    '地点': '地点',
    '吉隆坡（小学校区），雪兰莪沙登 Seri Kembangan（中学校区）': '吉隆坡（小学校区），雪兰莪沙登 Seri Kembangan（中学校区）',
    '创办年份': '创办年份',
    '1946年': '1946年',
    '课程体系': '课程体系',
    '英式课程': '英式课程',
    '性质': '性质',
    '非营利': '非营利',
    '提供 A Level 科目': '提供 A Level 科目',
    '24 科': '24 科',
    '学生生源国数量': '学生生源国数量',
    '来自53个不同的国家': '来自53个不同的国家',
    '师资来自英国': '师资来自英国',
    '学生已确认其首选大学的录取通知书': '学生已确认其首选大学的录取通知书',
    'A Level 成绩为 A* 至 A': "A Level 成绩为 A* 至 A",
    'A Level 成绩为 A* 至 B': "A Level 成绩为 A* 至 B",
    "IGCSE 成绩为 A* 至 A（7 至 9 年级）": "IGCSE 成绩为 A* 至 A（7 至 9 年级）",
    '学生获得首选的世界大学录取': "学生获得首选的世界大学录取",
    '申请费': "申请费",
    '马币 1,200': "马币 1,200",
    '注册费': "注册费",
    '马币 5,000': "马币 5,000",
    "幼儿园学费 3 岁-4 岁（一年）": "幼儿园学费 3 岁-4 岁（一年）",
    "马币 43,350 – 马币 57,570": "马币 43,350 – 马币 57,570",
    "1-6年级学费（一年）": "1-6年级学费（一年）",
    "马币 75,840 – 马币 79,920": "马币 75,840 – 马币 79,920",
    "7-13年级学费（一年）": "7-13年级学费（一年）",
    "马币 93,600 – 马币 101,910": "马币 93,600 – 马币 101,910",
    "不断寻求发展学生的学习体验": "不断寻求发展学生的学习体验",
    "平衡最新的教学研究和学习工具": "平衡最新的教学研究和学习工具",
    "每个孩子都被认识和欣赏": "每个孩子都被认识和欣赏",
    "无所畏惧鼓励开辟自己的道路": "无所畏惧鼓励开辟自己的道路",
    "激发勇敢的探索": "激发勇敢的探索",
    "激发一个更美好的世界": "激发一个更美好的世界",
    "英国国际学校理事会（COBIS）的认可成员": "英国国际学校理事会（COBIS）的认可成员",
    "英国国际学校亚洲联合会（FOBISIA）的创始成员": "英国国际学校亚洲联合会（FOBISIA）的创始成员",
    "东亚地区学校理事会 (EARCOS)": "东亚地区学校理事会 (EARCOS)",
    "国际学校理事会 (CIS) 的成员": "国际学校理事会 (CIS) 的成员",
    "2022 年 CASE 卓越圈奖": "2022 年 CASE 卓越圈奖",
    "2022 年 PIEoneer 奖": "2022 年 PIEoneer 奖",
    "国际学校奖项 2022": "国际学校奖项 2022",
    "中国和东南亚十五所顶尖学校之一": "中国和东南亚十五所顶尖学校之一",
    "全球领先的 100 所私立学校之一": "全球领先的 100 所私立学校之一",
    "InspirED 学校营销杰出奖": "InspirED 学校营销杰出奖",
    "2015 年 TES 国际学校年度奖": "2015 年 TES 国际学校年度奖",
    "2018 年英国国际学校奖 (BISA)": "2018 年英国国际学校奖 (BISA)",
    "吉隆坡英国国际学校 (BSKL)是 Nord Anglia 家族的骄傲成员，也是马来西亚领先的国际学校。 我们的快乐文化和个性化的学习方法激励每个学生取得最高水平。在 BSKL，您的孩子可以取得的成就是无限的。与往年相比，我们的学生在 IGCSE 和 A-level 成绩中取得了优异的成绩，世界一流的教师鼓励他们雄心勃勃，开辟自己的成功之路。 您的孩子将受益于发挥他们的才能、兴趣和愿望的个性化体验，这也将使他们在课堂之外取得最高水平。BSKL 积极的教育理念还培养适应力、同理心和沟通技巧，确保每个学生在个人、社交和情感上蓬勃发展。": "吉隆坡英国国际学校 (BSKL)是 Nord Anglia 家族的骄傲成员，也是马来西亚领先的国际学校。 我们的快乐文化和个性化的学习方法激励每个学生取得最高水平。在 BSKL，您的孩子可以取得的成就是无限的。与往年相比，我们的学生在 IGCSE 和 A-level 成绩中取得了优异的成绩，世界一流的教师鼓励他们雄心勃勃，开辟自己的成功之路。 您的孩子将受益于发挥他们的才能、兴趣和愿望的个性化体验，这也将使他们在课堂之外取得最高水平。BSKL 积极的教育理念还培养适应力、同理心和沟通技巧，确保每个学生在个人、社交和情感上蓬勃发展。",
    '雪兰莪八达灵再也（Petaling Jaya, Selangor）': "雪兰莪八达灵再也（Petaling Jaya, Selangor）",
    "2009年": "2009年",
    "英语国家课程": "英语国家课程",
    "私立国际学校": "私立国际学校",
    '来自63个不同的国家': '来自63个不同的国家',
    "教授语言": "教授语言",
    "4（英语、西班牙语、中文和法语）": "4（英语、西班牙语、中文和法语）",
    "提供": "提供",
    '幼儿班最小 2 岁和 A-Level': '幼儿班最小 2 岁和 A-Level',
    "2022/23 通过率": "2022/23 通过率",
    "2022 年 A-level 班取得 A* 或 A 成绩": "2022 年 A-level 班取得 A* 或 A 成绩",
    "2022 年 IGCSE 学生获得 5A*-C 成绩，包括数学和英语": "2022 年 IGCSE 学生获得 5A*-C 成绩，包括数学和英语",
    "考试通过率": "考试通过率",
    "毕业生就读于 QS 排名前 100 名的大学": "毕业生就读于 QS 排名前 100 名的大学",
    "2023 年 A-Level 取得了 A* 或 A 的成绩": "2023 年 A-Level 取得了 A* 或 A 的成绩",
    "2023 年 IGCSE 取得了 A* 或 A 成绩": "2023 年 IGCSE 取得了 A* 或 A 成绩",
    "马币 1,500": "马币 1,500",
    "马币 17,050": "马币 17,050",
    "幼儿园学费 2 岁-4 岁（一年）": "幼儿园学费 2 岁-4 岁（一年）",
    "马币 55,965 – 马币 67,665": "马币 55,965 – 马币 67,665",
    "马币 84,483 – 马币 104,340": "马币 84,483 – 马币 104,340",
    "7-11年级学费（一年）": "7-11年级学费（一年）",
    "马币 113,970 – 马币 131,145": "马币 113,970 – 马币 131,145",
    "12-13年级学费（一年）": "12-13年级学费（一年）",
    "马币 111,890": "马币 111,890",
    "培养适应力": "培养适应力",
    "同理心和沟通技巧": "同理心和沟通技巧",
    "确保每个学生在个人": "确保每个学生在个人",
    "社交和情感上蓬勃发展": "社交和情感上蓬勃发展",
    "获得了英国国际学校理事会 (COBIS)": "获得了英国国际学校理事会 (COBIS)",
    "亚洲英国国际学校联合会 (FOBISIA)": "亚洲英国国际学校联合会 (FOBISIA)",
    "剑桥大学国际考试中心的认证": "剑桥大学国际考试中心的认证",
    "培生爱德思 (Pearson Edexcel) 的认证": "培生爱德思 (Pearson Edexcel) 的认证",
    "马来西亚 Epsom 学院（ECiM）是一所于 2014 年成立的学校，旨在分享英国爱普森学院（ECUK）的教育理念，并在马来西亚提供高品质的英国教育。该学院位于森美兰州恩斯特克镇，占地 80 英亩，为 3 至 18 岁的学生提供教育。学校拥有最先进的设施，包括符合国际安全法规的高科技和环保建筑，以及齐全的体育设施。学生可以选择全寄宿、周寄宿和走读学校，学校采用传统的英国房屋制度，培养学生的归属感和社区意识。马来西亚 Epsom 学院特别重视教牧关怀，这被视为学校教育的标志，并贯穿于所有学校政策和实践中。学校的工作人员，包括教师、舍监、导师以及他们的家人，都居住在校园内，以确保学生始终感到安全。这种关怀的环境有助于学生全面发展，并在学业和个人生活中取得成功。": "马来西亚 Epsom 学院（ECiM）是一所于 2014 年成立的学校，旨在分享英国爱普森学院（ECUK）的教育理念，并在马来西亚提供高品质的英国教育。该学院位于森美兰州恩斯特克镇，占地 80 英亩，为 3 至 18 岁的学生提供教育。学校拥有最先进的设施，包括符合国际安全法规的高科技和环保建筑，以及齐全的体育设施。学生可以选择全寄宿、周寄宿和走读学校，学校采用传统的英国房屋制度，培养学生的归属感和社区意识。马来西亚 Epsom 学院特别重视教牧关怀，这被视为学校教育的标志，并贯穿于所有学校政策和实践中。学校的工作人员，包括教师、舍监、导师以及他们的家人，都居住在校园内，以确保学生始终感到安全。这种关怀的环境有助于学生全面发展，并在学业和个人生活中取得成功。",
    '森美兰州 Bandar Enste': '森美兰州 Bandar Enstek',
    '2014年': '2014年',
    '学期（一年）': '学期（一年）',
    '3个（9月至7月）': '3个（9月至7月）',
    '来自53个不同的国家': '来自53个不同的国家',
    "成绩为 A* 至 B": "成绩为 A* 至 B",
    "获得首选世界大学学位": "获得首选世界大学学位",
    "取得了 A*-B 成绩": "取得了 A*-B 成绩",
    "取得了至少 3 个 A* 或 A 成绩": "取得了至少 3 个 A* 或 A 成绩",
    "毕业生前往英国进行高等教育": "毕业生前往英国进行高等教育",
    "马币 1,000": "马币 1,000",
    "（幼儿园 - 2 年级）马币 10,000\n（3 年级 - 13 年级）马币 20,000": "（幼儿园 - 2 年级）马币 10,000\n（3 年级 - 13 年级）马币 20,000",
    "幼儿园学费（一年）": "幼儿园学费（一年）",
    "马币 48,000": "马币 48,000",
    "马币 69,163 – 马币 83,805": "马币 69,163 – 马币 83,805",
    "马币 95,850 – 马币 103,440": "马币 95,850 – 马币 103,440",
    "卓越的全方位机会——学术、社会、体育和文化": "卓越的全方位机会——学术、社会、体育和文化",
    "学生坚韧地追求卓越并适应压力环境": "学生坚韧地追求卓越并适应压力环境",
    "敢于开拓自己道路": "敢于开拓自己道路",
    "价值观：有礼貌，无私，努力工作，关爱环境和谦逊": "价值观：有礼貌，无私，努力工作，关爱环境和谦逊",
    "花园国际学校（ GIS）是马来西亚最早的 英 式 国际学校之一 ，成立于 1951年 。 花园国际学校是一所包容性和多元化的学校，在吉隆坡设有两个校区。在为吉隆坡当地和国际社区提供世界一流的教育方面拥有 70 多年的经验。花园国际学校是一所直通学校，教育3至18岁的学生。花园国际学校的课程都经过精心设计，以达到最终目的，以确保学生具备“为未来做好准备”的知识、技能和理解力，为他们进入教育大学的下一阶段做好准备。\n\n从课堂上的“教学课程”到课堂外更广泛的学习机会，包括花园国际学校为高中生提供的独特的 GIS 选修课程，花园国际学校的目标是培养兴趣、发展激情和培养人才，确保他们的学生具备所有这些能力在未来蓬勃发展。花园国际学校持续发展和取得的卓越成就，并为学校未来的成功奠定了坚实的基础 。": "花园国际学校（ GIS）是马来西亚最早的 英 式 国际学校之一 ，成立于 1951年 。 花园国际学校是一所包容性和多元化的学校，在吉隆坡设有两个校区。在为吉隆坡当地和国际社区提供世界一流的教育方面拥有 70 多年的经验。花园国际学校是一所直通学校，教育3至18岁的学生。花园国际学校的课程都经过精心设计，以达到最终目的，以确保学生具备“为未来做好准备”的知识、技能和理解力，为他们进入教育大学的下一阶段做好准备。\n\n从课堂上的“教学课程”到课堂外更广泛的学习机会，包括花园国际学校为高中生提供的独特的 GIS 选修课程，花园国际学校的目标是培养兴趣、发展激情和培养人才，确保他们的学生具备所有这些能力在未来蓬勃发展。花园国际学校持续发展和取得的卓越成就，并为学校未来的成功奠定了坚实的基础 。",
    '吉隆坡满家乐地区': '吉隆坡满家乐地区',
    '1951年': '1951年',
    '英国课程': '英国课程',
    '3至18岁的课程': '3至18岁的课程',
    '信息通信技术 (ICT)发展': '信息通信技术 (ICT)发展',
    '1:1 IPAD计划': '1:1 IPAD计划',
    "GIS学生成功被世界QS排名前10大学录取": "GIS学生成功被世界QS排名前10大学录取",
    "GIS学生进入TOP 100大学": "GIS学生进入TOP 100大学",
    "成功进入首选大学": "成功进入首选大学",
    "A level获得 至少一个A*或A": "A level获得 至少一个A*或A",
    "A level全年级获得 A*或A": "A level全年级获得 A*或A",
    "A level获得 3A*或A以上": "A level获得 3A*或A以上",
    "A level获得 A*至B": "A level获得 A*至B",
    "A level获得 A*至C": "A level获得 A*至C",
    "IGCSE获得 至少一个A*或A": "IGCSE获得 至少一个A*或A",
    "IGCSE全年级获得 A*或A": "IGCSE全年级获得 A*或A",
    "IGCSE获得 8A*或A以上": 'IGCSE获得 8A*或A以上',
    "IGCSE获得 A*至B": "IGCSE获得 A*至B",
    "IGCSE获得 A*至C": "IGCSE获得 A*至C",
    "马币 1,300": "马币 1,300",
    "注册费：（幼儿园） 马币 10,000\n1年级 - 13 年级） 马币 20,000": "注册费：（幼儿园） 马币 10,000\n1年级 - 13 年级） 马币 20,000",
    "马币 47,040 - 马币 55,920": "马币 47,040 - 马币 55,920",
    "马币 73,890 – 马币 88,320": "马币 73,890 – 马币 88,320",
    "马币 97,110 – 马币 105,510": "马币 97,110 – 马币 105,510",
    "学习视为个人和终身对社交、情感和智力发展的追求": "学习视为个人和终身对社交、情感和智力发展的追求",
    "唤醒学习者各种形式的智力": "唤醒学习者各种形式的智力",
    "激发学习者对现实和抽象世界中一切事物的好奇心": "激发学习者对现实和抽象世界中一切事物的好奇心",
    "利用丰富而真实的学习经历来培养天赋": "利用丰富而真实的学习经历来培养天赋",
    "提供在课堂内外追求兴趣和激情": "提供在课堂内外追求兴趣和激情",
    "追求卓越的机会": "追求卓越的机会",
    "一切都本着尊重、正直和福祉的精神": "一切都本着尊重、正直和福祉的精神",
    "获得欧洲国际学校理事会（ECIS）认证": "获得欧洲国际学校理事会（ECIS）认证",
    "英国卫报评选花园国际学校为“世界最佳8所国际学校”之一": "英国卫报评选花园国际学校为“世界最佳8所国际学校”之一",
    "荣获2016年全球创新奖": "荣获2016年全球创新奖",
    "入围2016年TES独立学校奖年度英国国际学校计划": "入围2016年TES独立学校奖年度英国国际学校计划",
    "GL 国际卓越中心": "GL 国际卓越中心",
    "苹果杰出学校": "苹果杰出学校",
    "授予初级科学质量标志（PSQM）": "授予初级科学质量标志（PSQM）",
    "国际学校理事会 (CIS)": "国际学校理事会 (CIS)",
    "西部学校和学院协会 (WASC)": "西部学校和学院协会 (WASC)",
    "IGB 国际学校 (IGBIS) 是马来西亚一所顶尖的 IB 国际学校，提供国际文凭连续体的四个课程：小学课程(PYP)、中学课程 (MYP)、文凭课程 (DP) 和职业相关课程 (CP）。自 2014 年成立以来，IGBIS 一直致力于采用国际文凭 (IB)框架，因为它与学校的教育理念相符。IGBIS 相信教育的目标是赋予年轻人好奇心、开放思维和关爱他人的能力，使他们能够利用知识和批判性思维技能来应对本地和全球的复杂挑战。学校拥有宽敞设备齐全的教室以及其他丰富的设施，如 534 个座位的礼堂。学生在受过国际培训和经验丰富的教师的支持下，接受独特的支持性、跨文化的学习体验，培养创造力、创新性和包容性，并在学术和个人方面取得优异成绩。\n\nIGBIS 的教育理念和价值观得到国际文凭框架的支持，经常从联合国可持续发展目标的角度来看待。学校的毕业生是有原则的终身学习者，他们准备好为家人、朋友、社区等创造积极的改变。IGBIS 相信，对个人成长和影响力的关注也会丰富和提高学业成绩。事实上，根据研究，IB 学生比同龄人更有可能完成本科学位并继续深造。": "IGB 国际学校 (IGBIS) 是马来西亚一所顶尖的 IB 国际学校，提供国际文凭连续体的四个课程：小学课程(PYP)、中学课程 (MYP)、文凭课程 (DP) 和职业相关课程 (CP）。自 2014 年成立以来，IGBIS 一直致力于采用国际文凭 (IB)框架，因为它与学校的教育理念相符。IGBIS 相信教育的目标是赋予年轻人好奇心、开放思维和关爱他人的能力，使他们能够利用知识和批判性思维技能来应对本地和全球的复杂挑战。学校拥有宽敞设备齐全的教室以及其他丰富的设施，如 534 个座位的礼堂。学生在受过国际培训和经验丰富的教师的支持下，接受独特的支持性、跨文化的学习体验，培养创造力、创新性和包容性，并在学术和个人方面取得优异成绩。\n\nIGBIS 的教育理念和价值观得到国际文凭框架的支持，经常从联合国可持续发展目标的角度来看待。学校的毕业生是有原则的终身学习者，他们准备好为家人、朋友、社区等创造积极的改变。IGBIS 相信，对个人成长和影响力的关注也会丰富和提高学业成绩。事实上，根据研究，IB 学生比同龄人更有可能完成本科学位并继续深造。",
    '建校年份': '建校年份',
    '课程': '课程',
    '马来西亚唯一拥有全部四个课程的 IB 学校': '马来西亚唯一拥有全部四个课程的 IB 学校',
    '外籍老师比例': '外籍老师比例',
    '来自 35 个不同的国家': '来自 35 个不同的国家',
    '地理位置': '地理位置',
    '位于 Sierramas 地区': '位于 Sierramas 地区',
    "2023 年 IBDP 考试通过率高达 100%, 超过了世界 79.7% 的通过率。": "2023 年 IBDP 考试通过率高达 100%, 超过了世界 79.7% 的通过率。",
    "IGBIS 25% 的学生得分为 40 分及以上（满分 45 分）。": "IGBIS 25% 的学生得分为 40 分及以上（满分 45 分）。",
    "（幼儿园：3 和 4 岁）马币 5,000\n（5 岁 - 10 年级）马币 25,000\n（11 年级 - 12 年级） 马币 7,500": "（幼儿园：3 和 4 岁）马币 5,000\n（5 岁 - 10 年级）马币 25,000\n（11 年级 - 12 年级） 马币 7,500",
    "马币 43,900 - 马币 61,600": "马币 43,900 - 马币 61,600",
    "马币 74,800 – 马币 79,700": "马币 74,800 – 马币 79,700",
    "7-12年级学费（一年）": "7-12年级学费（一年）",
    "马币 88,500 – 马币 102,100": "马币 88,500 – 马币 102,100",
    "提供新的思维和合作方式": "提供新的思维和合作方式",
    "培养具有全球视野、批判性思维的创新者": "培养具有全球视野、批判性思维的创新者",
    "点燃思想：影响生活": "点燃思想：影响生活",
    "提供创新的国际教育，激励学习者对世界产生积极影响。": "提供创新的国际教育，激励学习者对世界产生积极影响。",
    "提供一个包容性的学习社区，使其学习者成为有爱心的全球公民。": "提供一个包容性的学习社区，使其学习者成为有爱心的全球公民。",
    "获得新英格兰学校与学院协会（NEASC）认证": "获得新英格兰学校与学院协会（NEASC）认证",
    "马来西亚国际学校协会 (AIMS)": "马来西亚国际学校协会 (AIMS)",
    "东亚地区学校理事会 (EARCOS)": "东亚地区学校理事会 (EARCOS)",
    "国际学校理事会 (CIS)": "国际学校理事会 (CIS)",
    "Next Frontier Inclusion 的成员": "Next Frontier Inclusion 的成员",
    "吉隆坡国际学校（ISKL）成立于 1965 年，是马来西亚第一所获得全面认可的国际学校，以其平衡良好的学术传统和创新的教学方法而享有卓越的国际声誉。 作为一所私立、非盈利、家长管理的学校，ISKL 在美国通过西部学校与学院协会（WASC）认证，在国际上通过国际学校理事会（CIS）认证。学校的教育目标是为学生提供高质量的教育，从预科班（3 岁）到高中文凭、国际学士学位文凭和大学先修课程。ISKL 为来自65 多个国家的 1600 多名学生提供教育，旨在培养学生对其他文化的欣赏能力。学校重视学生的社交、情感和道德发展，提供全面的教育计划，使他们在课堂之外也能取得优异成绩并过上平衡的生活。学生有丰富的机会参与具有挑战性的学术课程以及广泛的校际体育和活动。ISKL 的教师队伍由高素质且经验丰富的专业人士组成，三分之二拥有研究生学位。经验丰富的工作人员协助教师和行政管理，为学校的成功日常运营做出贡献。": "吉隆坡国际学校（ISKL）成立于 1965 年，是马来西亚第一所获得全面认可的国际学校，以其平衡良好的学术传统和创新的教学方法而享有卓越的国际声誉。 作为一所私立、非盈利、家长管理的学校，ISKL 在美国通过西部学校与学院协会（WASC）认证，在国际上通过国际学校理事会（CIS）认证。学校的教育目标是为学生提供高质量的教育，从预科班（3 岁）到高中文凭、国际学士学位文凭和大学先修课程。ISKL 为来自65 多个国家的 1600 多名学生提供教育，旨在培养学生对其他文化的欣赏能力。学校重视学生的社交、情感和道德发展，提供全面的教育计划，使他们在课堂之外也能取得优异成绩并过上平衡的生活。学生有丰富的机会参与具有挑战性的学术课程以及广泛的校际体育和活动。ISKL 的教师队伍由高素质且经验丰富的专业人士组成，三分之二拥有研究生学位。经验丰富的工作人员协助教师和行政管理，为学校的成功日常运营做出贡献。",
    '1965年': '1965年',
    '国际课程': '国际课程',
    '学生数量': '学生数量',
    '国际学生比例': '国际学生比例',
    '超过 80%': '超过 80%',
    '中国学生比例': '中国学生比例',
    '师资经验 10 年以上': '师资经验 10 年以上',
    '教师拥有硕士或博士学位': '教师拥有硕士或博士学位',
    '教师在 IBO 中也扮演着考官或顾问的角色': '教师在 IBO 中也扮演着考官或顾问的角色',
    '超过 60%': '超过 60%',
    '来自 65 个不同的国家': '来自 65 个不同的国家',
    '安邦使馆区': '安邦使馆区',
    "获得 IBDP 文凭的学生": "获得 IBDP 文凭的学生",
    "2023 届毕业生获得了双语 IB 文凭": "2023 届毕业生获得了双语 IB 文凭",
    "24%（ISKL 历史上最高）": "24%（ISKL 历史上最高）",
    "2022 年 IBDP 考试通过率高达": "2022 年 IBDP 考试通过率高达",
    "2022 届毕业生获得了双语 IB 文凭": "2022 届毕业生获得了双语 IB 文凭",
    "马币 1,690": "马币 1,690",
    "幼儿园：无\n1 年级 - 12 年级：马币 59,000": "幼儿园：无\n1 年级 - 12 年级：马币 59,000",
    "马币 65,900 - 马币 87,400": "马币 65,900 - 马币 87,400",
    "1-5年级学费（一年）": "1-5年级学费（一年）",
    "马币 108,500": "马币 108,500",
    "6-8年级学费（一年）": "6-8年级学费（一年）",
    "马币 122,600": "马币 122,600",
    "9-12 年级学费（一年）": "9-12 年级学费（一年）",
    "马币 134，600": "马币 134，600",
    "创造性思考": "创造性思考",
    "建设性协作": "建设性协作",
    "批判性推理": "批判性推理",
    "有效沟通": "有效沟通",
    "热情学习": "热情学习",
    "道德生活": "道德生活",
    "通过国际学校理事会 (CIS) 认证": "通过国际学校理事会 (CIS) 认证",
    "ISKL 于 1989 年获得授权，是马来西亚历史最悠久的 IB 世界学校": "ISKL 于 1989 年获得授权，是马来西亚历史最悠久的 IB 世界学校",
    "特殊教育网络和包容性协会成员": "特殊教育网络和包容性协会成员",
    "生态学校组织和绿色学校联盟的成员": "生态学校组织和绿色学校联盟的成员",
    "VOX ISKL 系列荣获 2024 年全球从业者国际论坛 (IFIP) 全球包容奖教育社会影响类别奖": "VOX ISKL 系列荣获 2024 年全球从业者国际论坛 (IFIP) 全球包容奖教育社会影响类别奖",
    "荣获 2023 年卓越教育奖、Think Global People & Relocate 奖": "荣获 2023 年卓越教育奖、Think Global People & Relocate 奖",
    "入围 2023 年国际学校奖多元化、公平、包容和正义类别。": "入围 2023 年国际学校奖多元化、公平、包容和正义类别。",
    "入围 2023 年 Talk Education Awards 教育公平、多元化和包容性创新类别。": "入围 2023 年 Talk Education Awards 教育公平、多元化和包容性创新类别。",
    "马来西亚中学周计划入围 2022 年教育创新启发课外活动 Talk Education Awards。": "马来西亚中学周计划入围 2022 年教育创新启发课外活动 Talk Education Awards。",
    "联合获奖者马来西亚 GBC 可持续发展领导奖 2022 年最佳新型绿色和可持续学术建筑。": "联合获奖者马来西亚 GBC 可持续发展领导奖 2022 年最佳新型绿色和可持续学术建筑。",
    "荣获 2019 年全球奖“可持续发展项目奖”": "荣获 2019 年全球奖“可持续发展项目奖”",
    "2019 Edge Malaysia-Pertubuhan Akitek Malaysia（PAM – 马来西亚建筑师协会）绿色卓越奖。": "2019 Edge Malaysia-Pertubuhan Akitek Malaysia（PAM – 马来西亚建筑师协会）绿色卓越奖。",
    "2019 年 PAM（马来西亚建筑师协会）卓越建筑金奖（教育）。": "2019 年 PAM（马来西亚建筑师协会）卓越建筑金奖（教育）。",
    "ISP 国际学校是一所真正的社区学校为 3 至 18 岁的学生提供国际早期课程（IEYC）和国际初级课程（IPC）大师级课程，注重学生的个人发展和成长。我们提供丰富多彩的课程和课外活动，鼓励学生在学术、体育、表演艺术和创意艺术等方面全面发展。ISP 国际学校的教职员工由高素质的专业人士组成，致力于为学生提供优质的教育和学习体验。ISP 的成就得到了国际认可，这证明了学校在教育质量方面的卓越表现。学生从早期教育中心开始，经过连续的教育，毕业后已经为未来的学习和职业生涯做好了充分准备。": "ISP 国际学校是一所真正的社区学校为 3 至 18 岁的学生提供国际早期课程（IEYC）和国际初级课程（IPC）大师级课程，注重学生的个人发展和成长。我们提供丰富多彩的课程和课外活动，鼓励学生在学术、体育、表演艺术和创意艺术等方面全面发展。ISP 国际学校的教职员工由高素质的专业人士组成，致力于为学生提供优质的教育和学习体验。ISP 的成就得到了国际认可，这证明了学校在教育质量方面的卓越表现。学生从早期教育中心开始，经过连续的教育，毕业后已经为未来的学习和职业生涯做好了充分准备。",
    '2011年': '2011年',
    '国际课程，如国际文凭（IB）和剑桥国际考试（CIE）': '国际课程，如国际文凭（IB）和剑桥国际考试（CIE）',
    '技术': '技术',
    '（小学）三年级及以上开始，所有学生都拥有个人 iPad、ISP 电子邮件地址和 Google Drive 帐户\n\n（中学）10 年级以上的学生都有一台个人笔记本电脑。': '（小学）三年级及以上开始，所有学生都拥有个人 iPad、ISP 电子邮件地址和 Google Drive 帐户\n\n（中学）10 年级以上的学生都有一台个人笔记本电脑。',
    '位于帝沙城市公园地区（Desa ParkCity）': '位于帝沙城市公园地区（Desa ParkCity）',
    "A-Level 成绩通过率": "A-Level 成绩通过率",
    "A level 获得 A*或 A": "A level 获得 A*或 A",
    "A level 获得 A*或 B": "A level 获得 A*或 B",
    "A level 获得 A*或 C": "A level 获得 A*或 C",
    "IGCSE 获得 A*或 A": "IGCSE 获得 A*或 A",
    "IGCSE 获得 A*或 B": "IGCSE 获得 A*或 B",
    "IGCSE 获得 A*或 C": "IGCSE 获得 A*或 C",
    "（幼儿园：3 和 4 岁）马币 2,000\n（1 年级 - 11 年级）马币 20,000\n（12 年级 - 13 年级） 马币 10，000": "（幼儿园：3 和 4 岁）马币 2,000\n（1 年级 - 11 年级）马币 20,000\n（12 年级 - 13 年级） 马币 10，000",
    "马币 23,400 - 马币 24,300": "马币 23,400 - 马币 24,300",
    "马币 37,800 – 马币 60,420": "马币 37,800 – 马币 60,420",
    "马币 72,000 – 马币 81,750": "马币 72,000 – 马币 81,750",
    "鼓励学生不断探索、学习和成长": "鼓励学生不断探索、学习和成长",
    "提供激励性的学习环境": "提供激励性的学习环境",
    "培养他们的好奇心和求知欲": "培养他们的好奇心和求知欲",
    "鼓励他们勇于挑战自我，追求卓越": "鼓励他们勇于挑战自我，追求卓越",
    "提供支持和关怀": "提供支持和关怀",
    "鼓励学生平衡学习、休闲和社交活动": "鼓励学生平衡学习、休闲和社交活动",
    "培养他们的自我意识和情感智慧": "培养他们的自我意识和情感智慧",
    "鼓励学生积极参与社区和全球事务": "鼓励学生积极参与社区和全球事务",
    "培养他们的社会责任感和全球意识": "培养他们的社会责任感和全球意识",
    "教导学生珍惜资源、尊重环境": "教导学生珍惜资源、尊重环境",
    "鼓励他们采取积极的行动，为环境和社会做出贡献": "鼓励他们采取积极的行动，为环境和社会做出贡献",
    "国际学校质量标志 (ISQM) 认证 – 金奖": "国际学校质量标志 (ISQM) 认证 – 金奖",
    "爱丁堡公爵铜奖": "爱丁堡公爵铜奖",
    "满家乐国际学校（M'KIS）不仅是一所卓越的教育机构，更是一个支持性的、紧密联系的社区学校，致力于通过综合方法激发每个孩子和家庭的潜力。M'KIS 提供了 IB 教育课程，包括幼儿教育至高中的各个阶段, 拥有世界一流的课程、来自全球各地充满活力的教师以及来自 50 多个国家的学生，因此成为寻求国际教育的家庭的首选。随着学校的不断发展，M'KIS 已经成熟，成为吉隆坡最受欢迎的国际学校之一。": "满家乐国际学校（M'KIS）不仅是一所卓越的教育机构，更是一个支持性的、紧密联系的社区学校，致力于通过综合方法激发每个孩子和家庭的潜力。M'KIS 提供了 IB 教育课程，包括幼儿教育至高中的各个阶段, 拥有世界一流的课程、来自全球各地充满活力的教师以及来自 50 多个国家的学生，因此成为寻求国际教育的家庭的首选。随着学校的不断发展，M'KIS 已经成熟，成为吉隆坡最受欢迎的国际学校之一。",
    '1994年': '1994年',
    '国际课程 （IB）, 美国高中课程': '国际课程 （IB）, 美国高中课程',
    '来自超过 50 个不同的国家': '来自超过 50 个不同的国家',
    '吉隆坡满家乐': '吉隆坡满家乐',
    "M’KIS IBDP 平均分数（2023 年全球平均值为 31.98）": "M’KIS IBDP 平均分数（2023 年全球平均值为 31.98）",
    "M’KIS 通过率 (2023 全球通过率为 79.30%)": "M’KIS 通过率 (2023 全球通过率为 79.30%)",
    "40 分及以上：": "40 分及以上：",
    "马币 1,700": "马币 1,700",
    "（幼儿园：3 和 4 岁）没有\n幼儿园：5 岁） 马币 8,500\n（1 年级 - 5 年级）马币 28,000\n（6 年级 - 8 年级） 马币 28，000\n（9 年级 - 12 年级）马币 28，000": "（幼儿园：3 和 4 岁）没有\n幼儿园：5 岁） 马币 8,500\n（1 年级 - 5 年级）马币 28,000\n（6 年级 - 8 年级） 马币 28，000\n（9 年级 - 12 年级）马币 28，000",
    "马币 33,280 - 马币 78,956": "马币 33,280 - 马币 78,956",
    "马币 96,800": "马币 96,800",
    "马币 108,160": "马币 108,160",
    "马币 118,976": "马币 118,976",
    "通过提高每个孩子的创造力、情感、社交和学术才能": "通过提高每个孩子的创造力、情感、社交和学术才能",
    "培养卓越的学术成就": "培养卓越的学术成就",
    "培养求知欲和对社区的深刻理解": "培养求知欲和对社区的深刻理解",
    "重视归属感和联系": "重视归属感和联系",
    "重视仁慈与慈悲": "重视仁慈与慈悲",
    "重视卓越与积极": "重视卓越与积极",

    "莱仕国际学校是马来西亚顶尖的国际学校之一，提供国际早期课程 (IEYC) 和国际初级课程 (IPC) 大师级课程、IGCSE 和国际文凭课程 (IB)，同时为 9 岁以上的学生提供国际寄宿体验。学校致力于培养具有国际视野的个人，通过 Nexus Way 为学习者提供支持。Nexus Way 由四个要素构成，包括关系、包容、创新和心态。这些要素构成了学校的教育理念基石。学校的学习环境展现了创新和进步，并且建立了一种基于信任、同情和尊重的文化。这就是 Nexus 方式。": "莱仕国际学校是马来西亚顶尖的国际学校之一，提供国际早期课程 (IEYC) 和国际初级课程 (IPC) 大师级课程、IGCSE 和国际文凭课程 (IB)，同时为 9 岁以上的学生提供国际寄宿体验。学校致力于培养具有国际视野的个人，通过 Nexus Way 为学习者提供支持。Nexus Way 由四个要素构成，包括关系、包容、创新和心态。这些要素构成了学校的教育理念基石。学校的学习环境展现了创新和进步，并且建立了一种基于信任、同情和尊重的文化。这就是 Nexus 方式。",
    '2008年': '2008年',
    '来自超过 28 个不同的国家': '来自超过 28 个不同的国家',
    '布城': '布城',
    "IGCSE 获得成绩通过率": "IGCSE 获得成绩通过率",
    "IGCSE 获得了 10 个 A* 或 A": "IGCSE 获得了 10 个 A* 或 A",
    "IGCSE 获得了 9、8 或 7 A* 或 A": "IGCSE 获得了 9、8 或 7 A* 或 A",
    "几位学生": "几位学生",
    "（幼儿园）马币 5,000 – 马币 10,000\n（1 年级 - 13 年级） 马币 20，000": "（幼儿园）马币 5,000 – 马币 10,000\n（1 年级 - 13 年级） 马币 20，000",
    "马币 43,452 - 马币 46,182": "马币 43,452 - 马币 46,182",
    "马币 56,100 – 马币 69,300": "马币 56,100 – 马币 69,300",
    "马币 78,270 – 马币 94,890": "马币 78,270 – 马币 94,890",
    "学习就是建立联系": "学习就是建立联系",
    "以多种方式进行学习": "以多种方式进行学习",
    "孩子可以通过看、听、做或所有这些方式的组合来学习": "孩子可以通过看、听、做或所有这些方式的组合来学习",
    "需要为复杂的思考时间创造时间——“慢思考”时间": "需要为复杂的思考时间创造时间——“慢思考”时间",
    "良好的健康对于有效的学习很重要": "良好的健康对于有效的学习很重要",
    "爱丁堡公爵国际奖": "爱丁堡公爵国际奖",
    "滕比国际学校在马来西亚一共拥有六间学校，分别是怡宝校区、槟城校区、Tropicana Aman 校区、Setia Eco Gardens 校区、Setia EcoHill 校区，以及我们今天要介绍的 Setia Eco Park 校区。Setia Eco Park 校区于 2008 年开业，无缝融合了国际学校和马来西亚国家学校，在教育、高质量教学和提供更广泛的学生体验方面享有盛誉。国际学校遵循国际小学课程（IPC）、英国国家课程（UK）、IGCSE 和 A-Level 课程，而马来西亚国家学校遵循马来西亚国家课程。学校整体的教学方法不仅有助于学术卓越，也有利于个性发展。通过创造学习环境，为学生提供必要的知识、信心和各种生活技能，为走向快速变化的社会打开通向各种可能性的大门。这里不是考试场所，而是一个在核心价值观之上提供更广泛体验的学校。鼓励学生积极参与学习，发现自己和周围世界的新事物。社区将来自不同文化和民族的学生聚集在一起，他们学会了培养相互尊重和自信，成为未来的全球公民。": "滕比国际学校在马来西亚一共拥有六间学校，分别是怡宝校区、槟城校区、Tropicana Aman 校区、Setia Eco Gardens 校区、Setia EcoHill 校区，以及我们今天要介绍的 Setia Eco Park 校区。Setia Eco Park 校区于 2008 年开业，无缝融合了国际学校和马来西亚国家学校，在教育、高质量教学和提供更广泛的学生体验方面享有盛誉。国际学校遵循国际小学课程（IPC）、英国国家课程（UK）、IGCSE 和 A-Level 课程，而马来西亚国家学校遵循马来西亚国家课程。学校整体的教学方法不仅有助于学术卓越，也有利于个性发展。通过创造学习环境，为学生提供必要的知识、信心和各种生活技能，为走向快速变化的社会打开通向各种可能性的大门。这里不是考试场所，而是一个在核心价值观之上提供更广泛体验的学校。鼓励学生积极参与学习，发现自己和周围世界的新事物。社区将来自不同文化和民族的学生聚集在一起，他们学会了培养相互尊重和自信，成为未来的全球公民。",
    '1960年': '1960年',
    '超出 2000': '超出 2000',
    '来自大约 20-30 个不同的国家': '来自大约 20-30 个不同的国家',
    '地理位置（6 间）': '地理位置（6 间）',
    '怡宝校区、槟城校区、Tropicana Aman 校区、Setia Eco Gardens 校区、Setia EcoHill 校区， Setia Eco Park 校区': '怡宝校区、槟城校区、Tropicana Aman 校区、Setia Eco Gardens 校区、Setia EcoHill 校区， Setia Eco Park 校区',

    "IGCSE 成绩在 A* 到 C 之间": "IGCSE 成绩在 A* 到 C 之间",
    "IGCSES 成绩从 A* 到 B": "IGCSES 成绩从 A* 到 B",
    "IGCSES 成绩从 A* 到 A": "IGCSES 成绩从 A* 到 A",
    "IGCSES 取得 A*/A 及以上成绩": "IGCSES 取得 A*/A 及以上成绩",
    "52 名学生": "52 名学生",
    "A-Level 获得全 A": "A-Level 获得全 A",
    "A-Level 成绩从 A* 到 A": "A-Level 成绩从 A* 到 A",
    "A-Level 成绩从 A* 到 B": "A-Level 成绩从 A* 到 B",
    "A-Level 通过率": "A-Level 通过率",
    "马币 1,600": "马币 1,600",
    "马币 5,500": "马币 5,500",
    "马币 19，650": "马币 19，650",
    "马币 23,580 – 马币 42，000": "马币 23,580 – 马币 42，000",
    "马币 47，700 – 马币 61，200": "马币 47，700 – 马币 61，200",
    "A-Level 学费": "A-Level 学费",
    " 马币 64,000": " 马币 64,000",
    "预科学费": "预科学费",
    "马币 22，000": "马币 22，000",
    "教育不仅仅是学业成绩": "教育不仅仅是学业成绩",
    "教育涉及培养学术、社交或情感方面": "教育涉及培养学术、社交或情感方面",
    "学校环境以及学生感受到联系、接受和尊重的程度，会严重影响他们的学业成绩、心理健康和整体学校的成功。": "学校环境以及学生感受到联系、接受和尊重的程度，会严重影响他们的学业成绩、心理健康和整体学校的成功。",
    "CIS 国际学校协会": "CIS 国际学校协会",
    "WASC 美国西部院校协会": "WASC 美国西部院校协会",
    "AIMS 马来西亚国际学校联盟": "AIMS 马来西亚国际学校联盟",

    "吉隆坡泰勒国际学校（前身为 Sekolah Sri Garden）成立于 1991 年。当时其吉隆坡校区最初是为马来西亚羽毛球协会运动员设立的学校。该学校成为马来西亚顶尖的私立学校，经历了多年的变革，包括引入国际课程以及更名为泰莱国际学校。TIS 还扩建了位于蒲种的第二个校区。它拥有两个校区，旨在成为卓越的邻里国际学校，并延续泰勒卓越的教育传统。这两所学校隶属于泰莱教育集团，同样隶属于泰莱教育集团的国际学校有：澳大利亚国际学校（澳大利亚课程）、花园国际学校（英国课程）、Nexus 国际学校（英国课程）和泰莱大学。": "吉隆坡泰勒国际学校（前身为 Sekolah Sri Garden）成立于 1991 年。当时其吉隆坡校区最初是为马来西亚羽毛球协会运动员设立的学校。该学校成为马来西亚顶尖的私立学校，经历了多年的变革，包括引入国际课程以及更名为泰莱国际学校。TIS 还扩建了位于蒲种的第二个校区。它拥有两个校区，旨在成为卓越的邻里国际学校，并延续泰勒卓越的教育传统。这两所学校隶属于泰莱教育集团，同样隶属于泰莱教育集团的国际学校有：澳大利亚国际学校（澳大利亚课程）、花园国际学校（英国课程）、Nexus 国际学校（英国课程）和泰莱大学。",
    '1991年': '1991年',
    '蒲种/吉隆坡': '蒲种/吉隆坡',
    "2023 年 IGCSE A*-A 级": "2023 年 IGCSE A*-A 级",
    "2023 年 IGCSE A*-B 级": "2023 年 IGCSE A*-B 级",
    "2023 年 IGCSE A*-C 级": "2023 年 IGCSE A*-C 级",
    "（幼儿园）马币 5,000\n1 年级 - 16 年级） 马币 6，000": "（幼儿园）马币 5,000\n1 年级 - 16 年级） 马币 6，000",
    "马币 16,950": "马币 16,950",
    "马币 23,940 – 马币 36,960": "马币 23,940 – 马币 36,960",
    "马币 42,900 – 马币 49,890": "马币 42,900 – 马币 49,890",
    "马币 42，900-马币 49，890": "马币 42，900-马币 49，890",


    "互相尊重和关心": "互相尊重和关心",
    "致力于卓越文化": "致力于卓越文化",
    "沟通中的开放性": "沟通中的开放性",
    "诚信行事": "诚信行事",
    "对我们所做的事情充满热情": "对我们所做的事情充满热情",
    "创造愉快的环境": "创造愉快的环境",
    "获得量子学习名校奖项": "获得量子学习名校奖项",
    "荣获《读者文摘》可信品牌奖金奖": "荣获《读者文摘》可信品牌奖金奖",
    "国际课程协会（ICA）认证学校": "国际课程协会（ICA）认证学校",
    "2017 年 FIABCI-马来西亚房地产奖": "2017 年 FIABCI-马来西亚房地产奖",
    "剑桥国际教育（CIE）": "剑桥国际教育（CIE）",
    "12 项世界顶级奖项 (自 2012 年 IGCSE 杰出剑桥学习者奖)": "12 项世界顶级奖项 (自 2012 年 IGCSE 杰出剑桥学习者奖)",
    "16 项马来西亚顶级奖项 (自 2012 年 IGCSE 杰出剑桥学习者奖)": "16 项马来西亚顶级奖项 (自 2012 年 IGCSE 杰出剑桥学习者奖)",
    "TISKL 生态学校铜奖": "TISKL 生态学校铜奖",
    "吉隆坡绿洲国际学校由绿洲国际学校拥有和运营，绿洲国际学校是一个非营利组织，“致力于在世界各地建立和维护美式英语国际学校”。绿洲国际学校的网络位于美国田纳西州孟菲斯附近，但遍布世界各地，在 15个不同国家设有学校。 绿洲国际学校为吉隆坡绿洲国际学校提供资源、监督和支持。 自从成立 30 年以来，绿洲国际学校网络创造了卓越的学术成就、并为学生提供了丰富的大学录取机会以及成功的校友资源。": "吉隆坡绿洲国际学校由绿洲国际学校拥有和运营，绿洲国际学校是一个非营利组织，“致力于在世界各地建立和维护美式英语国际学校”。绿洲国际学校的网络位于美国田纳西州孟菲斯附近，但遍布世界各地，在 15个不同国家设有学校。 绿洲国际学校为吉隆坡绿洲国际学校提供资源、监督和支持。 自从成立 30 年以来，绿洲国际学校网络创造了卓越的学术成就、并为学生提供了丰富的大学录取机会以及成功的校友资源。",
    '雪兰莪州直落邦里玛嘉朗太子城(Bandar Saujana Putra)': '雪兰莪州直落邦里玛嘉朗太子城(Bandar Saujana Putra)',
    '2018年': '2018年',
    '美式 AP 课程': '美式 AP 课程',
    '在校学生人数': '在校学生人数',
    '300 人': '300 人',
    '国际生比例': '国际生比例',
    '招生年龄范围': '招生年龄范围',
    '4 岁 ~ 19 岁': '4 岁 ~ 19 岁',
    "马币 10,000": "马币 10,000",
    "马币 30，000": "马币 30，000",
    "马币 51，000": "马币 51，000",
    "马币 62，000": "马币 62，000",
    "马币 72，500": "马币 72，500",
    "英语学习费用（一年）": "英语学习费用（一年）",
    "马币 10，000 – 15，000（适用于需要额外英语学习支持的学生）": "马币 10，000 – 15，000（适用于需要额外英语学习支持的学生）",
    '互相尊重和关心': "互相尊重和关心",
    '致力于卓越文化': "致力于卓越文化",
    '沟通中的开放性': "沟通中的开放性",
    '诚信行事': "诚信行事",
    '对我们所做的事情充满热情': "对我们所做的事情充满热情",
    '创造愉快的环境': "创造愉快的环境",
    "西部学校与学院协会学校认证委员会（ACS WASC）": "西部学校与学院协会学校认证委员会（ACS WASC）",
    "成为 CIS 成员（将国际和跨文化视角融入其课程）": "成为 CIS 成员（将国际和跨文化视角融入其课程）",
    "获得 Common Sense School 徽章": "获得 Common Sense School 徽章",
    "参于儿童保护意识培训": "参于儿童保护意识培训",
    "成为 AIMS 成员": "成为 AIMS 成员",
    "成为 WIDA 国际学校联盟的成员": "成为 WIDA 国际学校联盟的成员",
    "与 HOSA（全球学生主导组织）合作": "与 HOSA（全球学生主导组织）合作",

    //Contact Us
    "易马海外": "易马海外",
    "电话热线": "电话热线",
    "电话": "电话",
    "Mon-Fri | 9:30AM - 6:00PM": "星期一 至 星期五 | 9:30 上午 - 6:30 下午",
    "YMG ( MM2H ) Sdn. Bhd. ( 129843-A), G-Tower Suite 16-05 & 16-07, GTower, No. 199, Jalan Tun Razak, 50400, Kuala Lumpur.": "YMG ( MM2H ) Sdn. Bhd. ( 129843-A), G-Tower Suite 16-05 & 16-07, GTower, No. 199, Jalan Tun Razak, 50400, Kuala Lumpur.",

    //Footer
    "构筑未来  启迪智慧": "构筑未来  启迪智慧",
    "搭建开发者与教育之桥": "搭建开发者与教育之桥",
    "易马海外成立于2014年，总部位于马来西亚首都【吉隆坡】，专业提供马来西亚房产、第二家园签证和国际留学咨询服务。我们秉承“客户为本、优质服务”的理念，为客户分析个人家庭需求，提供最适合的房产和家庭签证选择。以全面透明的服务为信念，让您安心地在马来西亚找到理想家园！多年来，易马海外家园已协助众多外籍家庭实现在马来西亚的美好生活。": "易马海外成立于2014年，总部位于马来西亚首都【吉隆坡】，专业提供马来西亚房产、第二家园签证和国际留学咨询服务。我们秉承“客户为本、优质服务”的理念，为客户分析个人家庭需求，提供最适合的房产和家庭签证选择。以全面透明的服务为信念，让您安心地在马来西亚找到理想家园！多年来，易马海外家园已协助众多外籍家庭实现在马来西亚的美好生活。",
    "星期一 至 星期五 | 9:30 上午 - 6:30 下午": "星期一 至 星期五 | 9:30 上午 - 6:30 下午",
    "Copyright ©YMG (MM2H) SDN BHD 201801031818 (1293843-A) All Rights Reserved.": "Copyright ©YMG (MM2H) SDN BHD 201801031818 (1293843-A) All Rights Reserved.",
}

export default ZH_CN;